// XyGIS sourcesDescription population + post-assignment zone fixups.
// Extracted from rawConfig.ts as part of Phase 4.4.
import {IConfig} from '../../core/interfaces/reducers'
import {ViewSchemaType} from '../../core/enums/ViewSchemaType'
import {matrixFields, parcelFields, siteParcelFields} from './fields'

export function populateXySources(rawConfig: IConfig, xyApiUrl: string): void {
  rawConfig.sourcesDescription[xyApiUrl] = {
    serviceType: 'xyGis',
    namespaces: {
      Reg: {
        reg: {
          layers: {
            PlanPrintCoordinate: {
              nonserver: true,
              sourceTitle: 'Точки за скица',
              idField: 'Id',
              hasAttachments: false,
              addOnMap: true,
              visible: true,
              readOnly: true,
              noRegister: true,
              doNotIdentify: true,
              z: 9,
              noLegend: true,
              pseudoViewSchema: {0: ViewSchemaType.Vector},
              vectorRenderer: {
                def: [
                  {
                    circle: {
                      stroke: {
                        color: 'red',
                        width: 1
                      },
                      fill: {
                        color: 'rgba(0,0,0,0)'
                      }
                    },
                    text: {
                      textFunction: "feature.getProperties()['Number'] || ''",
                      fillColor: 'red',
                      offsetX: -10,
                      offsetY: -10,
                      offsetFunc:
                        "[Math.sin(feature.get('Rotation') || 0) * 14, Math.cos(feature.get('Rotation') || 0) * 14]"
                    }
                  }
                ]
              },
              featureTitle: {
                bg: '{Number}'
              },
              fieldInfos: {}
            },
            Measures: {
              nonserver: true,
              sourceTitle: 'Измервания',
              idField: 'Id',
              hasAttachments: false,
              addOnMap: true,
              visible: true,
              readOnly: true,
              noRegister: true,
              doNotIdentify: true,
              z: 11,
              noLegend: true,
              pseudoViewSchema: {0: ViewSchemaType.Vector},
              minimumz: 0,
              vectorRenderer: {
                def: [
                  {
                    stroke: {
                      color: 'red',
                      width: 1
                    }
                  },
                  {
                    geometry: `var geom = feature.getGeometry();
                                    if(geom && geom.getCoordinates().length > 1){
                                        return geom.getCenter();
                                    }`,
                    text: {
                      textFunction: `distance`,
                      fillColor: 'red',
                      offsetY: -10,
                      font: '12px sans-serif'
                    }
                  }
                ]
              },
              featureTitle: {
                bg: '{Number}'
              },
              fieldInfos: {}
            },
            cadPreviewLine: {
              nonserver: true,
              sourceTitle: 'Временна визуализация',
              idField: 'Id',
              hasAttachments: false,
              addOnMap: true,
              visible: true,
              readOnly: true,
              noRegister: true,
              doNotIdentify: true,
              z: 11,
              noLegend: true,
              pseudoViewSchema: {0: ViewSchemaType.Vector},
              minimumz: 0,
              vectorRenderer: {
                nomenclature: {
                  field: 'Layer',
                  values: {
                    RP_OS: [
                      {
                        stroke: {
                          color: 'red',
                          width: 1,
                          lineDash: [9, 5, 2, 5]
                        }
                      }
                    ],
                    RP_REGO: [
                      {
                        stroke: {
                          color: 'red',
                          width: 0.5
                        }
                      }
                    ],
                    RP_PAR: [
                      {
                        stroke: {
                          color: 'blue',
                          width: 0.5
                        }
                      }
                    ],
                    'Граница нематериализирана': [
                      {
                        stroke: {
                          color: 'black',
                          width: 1
                        }
                      }
                    ],
                    'Линия за сграи': [
                      {
                        stroke: {
                          color: 'black',
                          width: 1
                        }
                      }
                    ],
                    'Паянтова ограда': [
                      {
                        stroke: {
                          color: 'black',
                          width: 1
                        }
                      },
                      {
                        stroke: {
                          color: 'black',
                          width: 2,
                          lineDash: [2, 5]
                        }
                      }
                    ],
                    'Паянтова ограда обща': [
                      {
                        stroke: {
                          color: 'black',
                          width: 1
                        }
                      }
                    ],
                    'Масивна ограда': [
                      {
                        stroke: {
                          color: 'black',
                          width: 1
                        }
                      }
                    ],
                    'Граница на кадастрален район': [
                      {
                        stroke: {
                          color: 'black',
                          width: 0.5
                        }
                      }
                    ]
                  }
                }
              },
              featureTitle: {
                bg: '{Layer}'
              },
              fieldInfos: {
                Layer: {
                  label: {
                    bg: 'Слой'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                }
              }
            },
            cadPreviewContur: {
              nonserver: true,
              sourceTitle: 'Временна визуализация',
              idField: 'Id',
              hasAttachments: false,
              addOnMap: true,
              visible: true,
              readOnly: true,
              noRegister: true,
              doNotIdentify: true,
              z: 11,
              noLegend: true,
              pseudoViewSchema: {0: ViewSchemaType.Vector},
              minimumz: 0,
              vectorRenderer: {
                nomenclature: {
                  field: 'Type',
                  values: {
                    'CADASTER/1': [
                      {
                        stroke: {
                          color: 'black',
                          width: 0.5
                        },
                        text: {
                          textFunction: "feature.getProperties()['Name'].split('.').pop() || ''",
                          fillColor: 'black'
                        }
                      }
                    ],
                    'CADASTER/2': [
                      {
                        text: {
                          textFunction: "feature.getProperties()['Name'].split('.').pop() || ''",
                          fillColor: 'black'
                        }
                      }
                    ],
                    'CADASTER/3': [
                      {
                        text: {
                          textFunction: "feature.getProperties()['Name'].split('.').pop() || ''",
                          fillColor: 'black'
                        }
                      }
                    ],
                    'CADASTER/4': [
                      {
                        text: {
                          textFunction: "feature.getProperties()['Name'].split('.').pop() || ''",
                          fillColor: 'black'
                        }
                      }
                    ]
                  }
                }
              },
              featureTitle: {
                bg: '{Layer}'
              },
              fieldInfos: {
                Layer: {
                  label: {
                    bg: 'Слой'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                }
              }
            },
            cadPreviewText: {
              nonserver: true,
              sourceTitle: 'Временна визуализация',
              idField: 'Id',
              hasAttachments: false,
              addOnMap: true,
              visible: true,
              readOnly: true,
              noRegister: true,
              doNotIdentify: true,
              z: 11,
              noLegend: true,
              pseudoViewSchema: {0: ViewSchemaType.Vector},
              minimumz: 0,
              vectorRenderer: {
                nomenclature: {
                  field: 'Type',
                  values: {
                    'CADASTER/17': [
                      {
                        stroke: {
                          color: 'black',
                          width: 0.4
                        },
                        text: {
                          textFunction: "feature.getProperties()['Text'] || ''",
                          fillColor: 'black'
                        }
                      }
                    ],
                    'REGPLAN/4': [
                      {
                        stroke: {
                          color: 'purple',
                          width: 0.3
                        },
                        text: {
                          textFunction: "feature.getProperties()['Text'] || ''",
                          fillColor: 'purple'
                        }
                      }
                    ],
                    'REGPLAN/60': [
                      {
                        stroke: {
                          color: 'blue',
                          width: 0.3
                        },
                        text: {
                          textFunction: "feature.getProperties()['Text'] || ''",
                          fillColor: 'blue'
                        }
                      }
                    ],
                    'REGPLAN/61': [
                      {
                        stroke: {
                          color: 'red',
                          width: 0.5
                        },
                        text: {
                          textFunction: "feature.getProperties()['Text'] || ''",
                          fillColor: 'red'
                        }
                      }
                    ],
                    'REGPLAN/62': [
                      {
                        stroke: {
                          color: 'red',
                          width: 0.5
                        },
                        circle: {
                          stroke: {
                            color: 'red',
                            width: 2
                          },
                          fill: {
                            color: '#00000000'
                          },
                          radius: 20
                        },
                        text: {
                          textFunction: "feature.getProperties()['Text'] || ''",
                          fillColor: 'red'
                        }
                      }
                    ],
                    'REGPLAN/63': [
                      {
                        stroke: {
                          color: 'blue',
                          width: 0.5
                        },
                        text: {
                          textFunction: "feature.getProperties()['Text'] || ''",
                          fillColor: 'blue'
                        }
                      }
                    ],
                    'REGPLAN/64': [
                      {
                        stroke: {
                          color: 'red',
                          width: 0.5
                        },
                        text: {
                          textFunction: "feature.getProperties()['Text'] || ''",
                          fillColor: 'red'
                        }
                      }
                    ],
                    'REGPLAN/65': [
                      {
                        stroke: {
                          color: 'blue',
                          width: 0.5
                        },
                        text: {
                          textFunction: "feature.getProperties()['Text'] || ''",
                          fillColor: 'blue'
                        }
                      }
                    ]
                  }
                }
              },
              featureTitle: {
                bg: '{Layer}'
              },
              fieldInfos: {
                Layer: {
                  label: {
                    bg: 'Слой'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                }
              }
            },
            Perpendiculars: {
              nonserver: true,
              sourceTitle: 'Перпендикуляри',
              idField: 'Id',
              hasAttachments: false,
              addOnMap: true,
              visible: true,
              readOnly: true,
              noRegister: true,
              doNotIdentify: true,
              z: 9,
              minimumz: 0,
              noLegend: true,
              pseudoViewSchema: {0: ViewSchemaType.Vector},
              vectorRenderer: {
                def: [
                  {
                    stroke: {
                      color: 'gray',
                      width: 1,
                      lineDash: [2, 5]
                    }
                  }
                ]
              },
              featureTitle: {
                bg: '{Number}'
              },
              fieldInfos: {}
            },
            Parcel: {
              sourceTitle: 'УПИ',
              idField: 'Id',
              hasAttachments: true,
              z: 9,
              minimumz: 18,
              pseudoViewSchema: {18: ViewSchemaType.Vector},
              vectorRenderer: {
                nomenclature: {
                  field: 'ParcelTypeId',
                  values: {
                    '1': [
                      {
                        stroke: {
                          color: 'red',
                          width: 0.5
                        },
                        fill: {
                          color: 'rgba(0,0,0,0)'
                        },
                        img: {
                          src: 'resources/icons/ot.svg',
                          scale: 0.2
                        },
                        zIndex: 4
                      },
                      {
                        geometry: `var geom = feature.getGeometry();
                                            if(geom && feature.getProperties()['ParcelNumber']){
                                                return geom.getCenter();
                                            }`,
                        text: {
                          textFunction: "feature.getProperties()['ParcelNumber'] || ''",
                          fillColor: 'red',
                          offsetX: -10,
                          offsetY: -10
                        },
                        zIndex: 4
                      },
                      {
                        geometry: `var geom = feature.getGeometry();
                                                if(geom && feature.getProperties()['CadNumbers']){
                                                    return geom.getCenter();
                                                }`,
                        text: {
                          textFunction: "feature.getProperties()['CadNumbers'] || ''",
                          fillColor: 'red',
                          offsetX: 10,
                          offsetY: 10
                        },
                        zIndex: 4
                      },
                      {
                        geometry: `var geom = feature.getGeometry();
                                                if(geom && feature.getProperties()['PR1']){
                                                    return geom.getCenter();
                                                }`,
                        text: {
                          textFunction: "feature.getProperties()['PR1']|| ''",
                          fillColor: 'red',
                          offsetX: 0,
                          offsetY: 25
                        },
                        zIndex: 3
                      },
                      {
                        geometry: `var geom = feature.getGeometry();
                                                if(geom && feature.getProperties()['PR2']){
                                                    return geom.getCenter();
                                                }`,
                        text: {
                          textFunction: "feature.getProperties()['PR2'] || ''",
                          fillColor: 'red',
                          offsetX: 0,
                          offsetY: 40
                        },
                        zIndex: 3
                      },
                      {
                        geometry: `var geom = feature.getGeometry();
                                                if(geom && feature.getProperties()['PR3']){
                                                    return geom.getCenter();
                                                }`,
                        text: {
                          textFunction: "feature.getProperties()['PR3']  || ''",
                          fillColor: 'red',
                          offsetX: 0,
                          offsetY: 55
                        },
                        zIndex: 3
                      },
                      {
                        geometry: `var geom = feature.getGeometry();
                                                if(geom && feature.getProperties()['PR4']){
                                                    return geom.getCenter();
                                                }`,
                        text: {
                          textFunction: "feature.getProperties()['PR4'] || ''",
                          fillColor: 'red',
                          offsetX: 0,
                          offsetY: 70
                        },
                        zIndex: 3
                      },
                      {
                        geometry: `var geom = feature.getGeometry();
                                                if(geom && feature.getProperties()['PR5']){
                                                    return geom.getCenter();
                                                }`,
                        text: {
                          textFunction: "feature.getProperties()['PR5'] || ''",
                          fillColor: 'red',
                          offsetX: 0,
                          offsetY: 85
                        },
                        zIndex: 3
                      }
                    ],
                    '2': [
                      {
                        stroke: {
                          color: 'rgba(0, 127, 255, 1)',
                          width: 0.5
                        },
                        fill: {
                          color: 'rgba(0,0,0,0)'
                        },
                        img: {
                          src: 'resources/icons/ot.svg',
                          scale: 0.1
                        },
                        zIndex: 3
                      },
                      {
                        geometry: `var geom = feature.getGeometry();
                                            if(geom && feature.getProperties()['ParcelNumber']){
                                                return geom.getCenter();
                                            }`,
                        text: {
                          textFunction: "feature.getProperties()['ParcelNumber'] || ''",
                          fillColor: 'rgba(0, 127, 255, 1)',
                          offsetX: -10,
                          offsetY: -10
                        },
                        zIndex: 3
                      },
                      {
                        geometry: `var geom = feature.getGeometry();
                                                if(geom && feature.getProperties()['CadNumbers']){
                                                    return geom.getCenter();
                                                }`,
                        text: {
                          textFunction: "feature.getProperties()['CadNumbers'] || ''",
                          fillColor: 'rgba(0, 127, 255, 1)',
                          offsetX: 10,
                          offsetY: 10
                        },
                        zIndex: 3
                      },
                      {
                        geometry: `var geom = feature.getGeometry();
                                                if(geom && feature.getProperties()['PR1']){
                                                    return geom.getCenter();
                                                }`,
                        text: {
                          textFunction: "feature.getProperties()['PR1'] || ''",
                          fillColor: 'rgba(0, 127, 255, 1)',
                          offsetX: 0,
                          offsetY: 25
                        },
                        zIndex: 3
                      }
                    ]
                  }
                }
              },
              constantSqlWhere: '"OverriddenByRegPlanId" IS NULL',
              featureTitle: {
                bg: 'УПИ {ParcelNumber}-{CadNumbers}'
              },
              tableFields: ['ParcelNumber', 'CadNumbers', 'Owner'],
              fieldInfos: {
                ...parcelFields,
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Owner: {
                  label: {
                    bg: 'Собственик'
                  },
                  visible: true,
                  editable: true
                },
                OwnerDoc: {
                  label: {
                    bg: 'Текущ документ за собственост'
                  },
                  visible: true,
                  editable: true
                },
                QuarterNumber: {
                  label: {
                    bg: 'Квартал номер'
                  },
                  visible: true,
                  editable: false
                },
                Locality: {
                  label: {
                    bg: 'Местоположение'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                LocalityId: {
                  label: {
                    bg: 'Местоположение'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                MissingPlanName: {
                  label: {
                    bg: 'Информация/Предишни собственици'
                  },
                  visible: true,
                  editable: true,
                  length: 3000
                },
                SiteLineTypes: {
                  label: {
                    bg: 'SiteLineTypes'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                PlanName: {
                  label: {
                    bg: 'Номер на Заповед за план'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                PlanApprover: {
                  label: {
                    bg: 'Одобрен от'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                PlanTypeId: {
                  label: {
                    bg: 'Тип план'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  codedValues: [
                    {code: 1, name: 'Нов план'},
                    {code: 2, name: 'Изменение'},
                    {code: 3, name: 'Редактиран план'}
                  ]
                }
              }
            },
            Quarter: {
              sourceTitle: 'Квартали',
              idField: 'Id',
              hasAttachments: true,
              z: 9,
              pseudoViewSchema: {9: ViewSchemaType.TileImage, 18: ViewSchemaType.Vector},
              minimumz: 9,
              constantSqlWhere: '"OverriddenByRegPlanId" IS NULL',
              featureTitle: {
                bg: 'Квартал {QuarterNumber}'
              },
              vectorRenderer: {
                def: [
                  {
                    stroke: {
                      color: 'red',
                      width: 1
                    },
                    fill: {
                      color: '#00000000'
                    }
                  },
                  {
                    geometry: `var geom = feature.getGeometry();
                                    if(geom && feature.getProperties()['QuarterNumber']){
                                        return geom.getCenters();
                                    }`,
                    circle: {
                      stroke: {
                        color: 'red',
                        width: 2
                      },
                      fill: {
                        color: '#00000000'
                      },
                      radius: 20
                    }
                  },
                  {
                    text: {
                      textFunction: "feature.getProperties()['QuarterNumber'] || ''",
                      fillColor: 'red'
                    }
                  }
                ]
              },
              tableFields: ['QuarterNumber', 'Locality', 'SettlementName'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                RegPlanId: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Locality: {
                  label: {
                    bg: 'Местоположение'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                LocalityId: {
                  label: {
                    bg: 'Местоположение'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                SettlementName: {
                  label: {
                    bg: 'Населено място'
                  },
                  visible: true,
                  editable: false
                },
                PlanTypeId: {
                  label: {
                    bg: 'Тип план'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  codedValues: [
                    {code: 1, name: 'Нов план'},
                    {code: 2, name: 'Изменение'},
                    {code: 3, name: 'Редакцтиран план'}
                  ]
                },
                PlanName: {
                  label: {
                    bg: 'Име на план'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                OverriddenByRegPlanId: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                QuarterNumber: {
                  label: {
                    bg: 'Номер'
                  },
                  visible: true,
                  editable: true
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                ApprovedDate: {
                  label: {
                    bg: 'Дата на одобряване'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                }
              }
            },
            EndRego: {
              sourceTitle: 'Край на регулация',
              idField: 'Id',
              hasAttachments: true,
              z: 9,
              pseudoViewSchema: {9: ViewSchemaType.Vector},
              minimumz: 9,
              constantSqlWhere: '"OverriddenByRegPlanId" IS NULL',
              featureTitle: {
                bg: 'Край на регулация'
              },
              vectorRenderer: {
                def: [
                  {
                    stroke: {
                      color: 'red',
                      width: 1
                    },
                    fill: {
                      color: '#00000000'
                    }
                  }
                ]
              },
              tableFields: ['QuarterNumber', 'Locality', 'SettlementName'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                RegPlanId: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Locality: {
                  label: {
                    bg: 'Местоположение'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                LocalityId: {
                  label: {
                    bg: 'Местоположение'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                PlanTypeId: {
                  label: {
                    bg: 'Тип план'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  codedValues: [
                    {code: 1, name: 'Нов план'},
                    {code: 2, name: 'Изменение'},
                    {code: 3, name: 'Редакцтиран план'}
                  ]
                },
                PlanName: {
                  label: {
                    bg: 'Име на план'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                OverriddenByRegPlanId: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                ApprovedDate: {
                  label: {
                    bg: 'Дата на одобряване'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                }
              }
            },
            RegGreenLine: {
              sourceTitle: 'Озеленяване',
              idField: 'Id',
              hasAttachments: true,
              z: 9,
              pseudoViewSchema: {12: ViewSchemaType.Vector},
              minimumz: 9,
              constantSqlWhere: '"OverriddenByRegPlanId" IS NULL',
              featureTitle: {
                bg: 'Озеленяване'
              },
              vectorRenderer: {
                def: [
                  {
                    stroke: {
                      color: 'red',
                      width: 1
                    },
                    fill: {
                      color: '#00000000'
                    }
                  }
                ]
              },
              tableFields: ['QuarterNumber', 'Locality', 'SettlementName'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                RegPlanId: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Locality: {
                  label: {
                    bg: 'Местоположение'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                LocalityId: {
                  label: {
                    bg: 'Местоположение'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                PlanTypeId: {
                  label: {
                    bg: 'Тип план'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  codedValues: [
                    {code: 1, name: 'Нов план'},
                    {code: 2, name: 'Изменение'},
                    {code: 3, name: 'Редакцтиран план'}
                  ]
                },
                PlanName: {
                  label: {
                    bg: 'Име на план'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                OverriddenByRegPlanId: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                ApprovedDate: {
                  label: {
                    bg: 'Дата на одобряване'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                }
              }
            },
            RegPlan: {
              readOnly: true,
              noLegend: true,
              sourceTitle: 'Планове и изменения',
              idField: 'Id',
              hasAttachments: true,
              z: 8,
              featureTitle: {
                bg: 'Линия: {PlanName}'
              },
              attachmentsReadOnly: true,
              pseudoViewSchema: {0: ViewSchemaType.None},
              tableFields: ['Id', 'PlanName', 'PlanDate', 'Created', 'RegPlanTypeId'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                ApprovedDate: {
                  label: {
                    bg: 'Влязло в сила на'
                  },
                  visible: true,
                  editable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                DateToCorrect: {
                  label: {
                    bg: 'За корекция'
                  },
                  visible: true,
                  editable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                PlanName: {
                  label: {
                    bg: 'Име'
                  },
                  visible: true,
                  editable: false
                },
                PlanDate: {
                  label: {
                    bg: 'Дата на план/изменение'
                  },
                  visible: true,
                  editable: false,
                  dateSupportsOffset: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                RegPlanTypeId: {
                  label: {
                    bg: 'Тип план'
                  },
                  visible: true,
                  editable: false
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                LocalityId: {
                  label: {
                    bg: ''
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            RegOsLine: {
              sourceTitle: 'Осови линии',
              idField: 'Id',
              z: 9,
              minimumz: 18,
              pseudoViewSchema: {9: ViewSchemaType.None, 18: ViewSchemaType.Vector},
              constantSqlWhere: '"OverriddenByRegPlanId" IS NULL',
              featureTitle: {
                bg: 'Осова линия'
              },
              vectorRenderer: {
                def: [
                  {
                    stroke: {
                      color: 'red',
                      width: 1,
                      lineDash: [9, 5, 2, 5]
                    }
                  }
                ]
              },
              fieldInfos: {
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                LocalityId: {
                  label: {
                    bg: ''
                  },
                  visible: false,
                  editable: false,
                  nullable: false
                },
                RegPlanId: {
                  label: {
                    bg: ''
                  },
                  visible: false,
                  editable: false,
                  nullable: false
                }
              }
            },
            RegLine: {
              sourceTitle: 'Бордюрна линия',
              idField: 'Id',
              z: 10,
              minimumz: 18,
              pseudoViewSchema: {10: ViewSchemaType.None, 18: ViewSchemaType.Vector},
              constantSqlWhere: '"OverriddenByRegPlanId" IS NULL',
              featureTitle: {
                bg: 'Бордюрна линия'
              },
              vectorRenderer: {
                def: [
                  {
                    stroke: {
                      color: 'rgba(0, 127, 255, 1)',
                      width: 1
                    }
                  }
                ]
              },
              fieldInfos: {
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            RegPoint: {
              sourceTitle: 'Осови точки',
              idField: 'Id',
              z: 10,
              minimumz: 18,
              pseudoViewSchema: {10: ViewSchemaType.None, 18: ViewSchemaType.Vector},
              constantSqlWhere: '"OverriddenByRegPlanId" IS NULL',
              featureTitle: {
                bg: 'Осова точка'
              },
              vectorRenderer: {
                def: [
                  {
                    circle: {
                      radius: 5,
                      stroke: {
                        width: 1,
                        color: 'red'
                      }
                    },
                    text: {
                      textFunction: `feature.getProperties()['Number'] || ''`,
                      fillColor: 'red',
                      offsetX: 15,
                      offsetY: 0,
                      font: '12px sans-serif'
                    }
                  },
                  {
                    circle: {
                      radius: 1,
                      stroke: {
                        width: 0,
                        color: 'red'
                      },
                      fill: {
                        color: 'red'
                      }
                    }
                  }
                ]
              },
              fieldInfos: {
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            StreetUnregulatedReg: {
              sourceTitle: 'Улична регулация (Допълнителна)',
              idField: 'Id',
              hasAttachments: false,
              addOnMap: true,
              visible: true,
              readOnly: false,
              doNotIdentify: false,
              z: 9,
              tableFields: ['Type', 'Created', 'CreatedBy'],
              minimumz: 10,
              pseudoViewSchema: {10: ViewSchemaType.Vector},
              vectorRenderer: {
                nomenclature: {
                  field: 'Type',
                  values: {
                    '1': [
                      {
                        stroke: {
                          color: 'red',
                          width: 1
                        }
                      }
                    ],

                    '2': [
                      {
                        stroke: {
                          color: 'red',
                          width: 1,
                          lineDash: [2, 5]
                        }
                      }
                    ]
                  }
                }
              },
              featureTitle: {
                bg: 'Улична регулация (Допълнителна)'
              },
              fieldInfos: {
                Type: {
                  label: {bg: ''},
                  visible: true,
                  codedValues: [
                    {
                      code: 1,
                      name: 'Плътна линия'
                    },
                    {
                      code: 2,
                      name: 'Пунктир'
                    }
                  ]
                },
                Id: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                geometry: {
                  type: 'geometry',
                  label: {bg: 'geometry'},
                  visible: false,
                  nullable: true,
                  editable: false
                }
              }
            }
          }
        },
        zones: {
          layers: {
            'MatrixZone#101': {
              sourceTitle: 'Жк - Жилищна устройствена зона с преобладаващо комплексно застрояване.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (101)`,
              color: '#ff9900'
            },
            'MatrixZone#102': {
              sourceTitle: 'Жм - Жилищна устройствена зона с преобладаващо застрояване с малка височина. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (102)`,
              color: '#ff9900'
            },
            'MatrixZone#103': {
              sourceTitle: 'Жс - Жилищна устройствена зона с преобладаващо застрояване със средна височина. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (103)`,
              color: '#ff9900'
            },
            'MatrixZone#104': {
              sourceTitle: 'Жс1 - Жилищна устройствена зона с преобладаващо застрояване със средна височина. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (104)`,
              color: '#ff9900'
            },
            'MatrixZone#105': {
              sourceTitle: 'Жг - Жилищна устройствена зона с преобладаващо застрояване с голяма височина. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (105)`,
              color: '#ff9900'
            },
            'MatrixZone#106': {
              sourceTitle: 'Жг1 - Жилищна устройствена зона с преобладаващо застрояване с голяма височина. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (106)`,
              color: '#ff9900'
            },
            'MatrixZone#107': {
              sourceTitle: 'Жг2 - Жилищна устройствена зона с преобладаващо застрояване с голяма височина. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (107)`,
              color: '#ff9900'
            },
            'MatrixZone#108': {
              sourceTitle: 'Жг3 - Жилищна устройствена зона с преобладаващо застрояване с голяма височина. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (108)`,
              color: '#ff9900'
            },
            'MatrixZone#109': {
              sourceTitle: 'Жг4 - Жилищна устройствена зона с преобладаващо застрояване с голяма височина. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (109)`,
              color: '#ff9900'
            },
            'MatrixZone#110': {
              sourceTitle: 'Жг5 - Жилищна устройствена зона с преобладаващо застрояване с голяма височина. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (110)`,
              color: '#ff9900'
            },
            'MatrixZone#111': {
              sourceTitle: 'Жг6 - Жилищна устройствена зона с преобладаващо застрояване с голяма височина. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (111)`,
              color: '#ff9900'
            },
            'MatrixZone#112': {
              sourceTitle: 'Жг7 - Жилищна устройствена зона с преобладаващо застрояване с голяма височина. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (112)`,
              color: '#ff9900'
            },

            'MatrixZone#113': {
              sourceTitle: 'Ж7 - Зона за обществено обслужване ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (113)`,
              color: '#f18484'
            },
            'MatrixZone#114': {
              sourceTitle: 'Ц - Смесена централна зона. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (114)`,
              color: '#f18484'
            },
            'MatrixZone#115': {
              sourceTitle: 'Ц1 - Смесена централна зона. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (115)`,
              color: '#f18484'
            },
            'MatrixZone#116': {
              sourceTitle: 'Ц2 - Смесена централна зона. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (116)`,
              color: '#f18484'
            },
            'MatrixZone#117': {
              sourceTitle: 'Ц3 - Смесена централна зона. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (117)`,
              color: '#f18484'
            },
            'MatrixZone#118': {
              sourceTitle: 'Цкин - Теротория с културно-историческо наследство',
              constantSqlWhere: `"MatrixZoneTypeId" IN (118)`,
              color: '#f18484'
            },

            'MatrixZone#119': {
              sourceTitle: 'Смф - Многофункционална устройствена зона с преобладаващо обществено обслужване. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (119)`,
              color: '#ff8080'
            },
            'MatrixZone#120': {
              sourceTitle: 'Смф1a - Многофункционална устройствена зона с преобладаващи производствени дейности. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (120)`,
              color: '#ff8080'
            },
            'MatrixZone#121': {
              sourceTitle: 'Смф1 - Многофункционална устройствена зона с преобладаващи производствени дейности. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (121)`,
              color: '#ff8080'
            },
            'MatrixZone#122': {
              sourceTitle:
                'Смф2 - Многофункционална устройствена зона с преобладаващо обществено обслужващи функции  и допълващо озеленяване. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (122)`,
              color: '#ff8080'
            },

            'MatrixZone#123': {
              sourceTitle:
                'Смф3 - Територия с многофункционално предназначение за обществено обслужване, търговия безвредни производства , жилища, спорт и атракции и други допълващи функции без да се допускат обекти за дейности с вредни отделяния и влияния.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (123)`,
              color: '#996633'
            },

            'MatrixZone#124': {
              sourceTitle: 'Оз - Устройствена зона за озеленяване, паркове и градини',
              constantSqlWhere: `"MatrixZoneTypeId" IN (124)`,
              color: '#339966'
            },

            'MatrixZone#125': {
              sourceTitle: 'Ов - Устройствена зона за вилно застрояване. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (125)`,
              color: '#ffff99'
            },

            'MatrixZone#126': {
              sourceTitle: 'Ок - Устройствена зона за рекреационни дейности. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (126)`,
              color: '#99cc00'
            },

            'MatrixZone#127': {
              sourceTitle: 'Од - Зони за озеленяване, спорт и атракции. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (127)`,
              color: '#548235'
            },

            'MatrixZone#128': {
              sourceTitle: 'Оа - Устройствени зони, предназначени за аграрен туризъм',
              constantSqlWhere: `"MatrixZoneTypeId" IN (128)`,
              color: '#ffc000'
            },

            'MatrixZone#129': {
              sourceTitle: 'Пч - Чисто производствена устройствена зона. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (129)`,
              color: '#cc99ff'
            },
            'MatrixZone#130': {
              sourceTitle: 'Пп - Предимно производствена устройствена зона. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (130)`,
              color: '#cc99ff'
            },
            'MatrixZone#131': {
              sourceTitle: 'Пс - Територии за едно или няколко предприятия, свързани в технологичен комплекс. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (131)`,
              color: '#cc99ff'
            },

            'MatrixZone#132': {
              sourceTitle: 'СТ - Специални терени на отбраната и сигурността',
              constantSqlWhere: `"MatrixZoneTypeId" IN (132)`,
              color: '#f8cbad'
            },

            'MatrixZone#133': {
              sourceTitle: 'Т - Зона със самостоятелен устройствен режим',
              constantSqlWhere: `"MatrixZoneTypeId" IN (133)`,
              color: '#ffffff'
            },

            'MatrixZone#134': {
              sourceTitle:
                '07079/1 - Смесена територия с преобладаващо предназначение за обществено обслужване и допълващо за безвредни производства. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (134)`,
              color: '#ff8080'
            },

            'MatrixZone#135': {
              sourceTitle:
                '07079/3 - Територия за производство на електроенергия от възобновяеми енергийни източници с коефициент на усвояване до 90% от площта на имота - фотоволтаици.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (135)`,
              color: '#cc99ff'
            },

            'MatrixZone#136': {
              sourceTitle:
                '07079/6 - Смесена територия с преобладаващо предназначение за обществено обслужване и допълващо за безвредни производства. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (136)`,
              color: '#ff8080'
            },
            'MatrixZone#137': {
              sourceTitle:
                '07079/7 - Смесена територия с преобладаващо предназначение за обществено обслужване и допълващо за безвредни производства. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (137)`,
              color: '#ff8080'
            },

            'MatrixZone#138': {
              sourceTitle: '07079/10 - Производствена територия. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (138)`,
              color: '#cc99ff'
            },

            'MatrixZone#139': {
              sourceTitle: '07079/11 - Земеделска територия с допустима промяна на предназначението.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (139)`,
              color: '#ffc000'
            },

            'MatrixZone#140': {
              sourceTitle:
                '07079/12 - Смесена територия с преобладаващо предназначение за обществено обслужване и допълващо за безвредни производства. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (140)`,
              color: '#ff8080'
            },

            'MatrixZone#141': {
              sourceTitle: '07079/13 - Земеделска територия с допустима промяна на предназначението. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (141)`,
              color: '#ffc000'
            },

            'MatrixZone#142': {
              sourceTitle: '07079/15 - Производствена територия.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (142)`,
              color: '#cc99ff'
            },

            'MatrixZone#143': {
              sourceTitle: '07079/16 - Земеделска територия с допустима промяна на предназначението.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (143)`,
              color: '#ffc000'
            },
            'MatrixZone#144': {
              sourceTitle: '07079/18 - Земеделска територия с допустима промяна на предназначението. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (144)`,
              color: '#ffc000'
            },

            'MatrixZone#145': {
              sourceTitle:
                '07079/19 - Смесена територия с преобладаващо предназначение за обществено обслужване и допълващо за безвредни производства. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (145)`,
              color: '#ff8080'
            },

            'MatrixZone#146': {
              sourceTitle: '07079/20 - Територии за озеленяване, спорт и атракции.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (146)`,
              color: '#548235'
            },

            'MatrixZone#147': {
              sourceTitle:
                '07079/21 - Смесена територия с преобладаващо предназначение за обществено обслужване и допълващо за безвредни производства.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (147)`,
              color: '#ff8080'
            },

            'MatrixZone#148': {
              sourceTitle: '07079/22 - Земеделска територия с допустима промяна на предназначението. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (148)`,
              color: '#ffc000'
            },
            'MatrixZone#149': {
              sourceTitle: '07079/23 - Земеделска територия с допустима промяна на предназначението. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (149)`,
              color: '#ffc000'
            },
            'MatrixZone#150': {
              sourceTitle: '07079/24 - Земеделска територия с допустима промяна на предназначението.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (150)`,
              color: '#ffc000'
            },

            'MatrixZone#151': {
              sourceTitle:
                '07079/25 - Смесена територия с преобладаващо предназначение за обществено обслужване и допълващо за безвредни производства.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (151)`,
              color: '#ff8080'
            },
            'MatrixZone#152': {
              sourceTitle:
                '07079/30 - Смесена територия с преобладаващо предназначение за обществено обслужване и допълващо за безвредни производства.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (152)`,
              color: '#ff8080'
            },

            'MatrixZone#153': {
              sourceTitle: '07079/31 - Територията попада изцяло в охранителна зона „Б“ според ЗУЧК. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (153)`,
              color: '#548235'
            },

            'MatrixZone#154': {
              sourceTitle: '07079/34 - Земеделска територия с допустима промяна на предназначението.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (154)`,
              color: '#ffc000'
            },
            'MatrixZone#155': {
              sourceTitle: '07079/35 - Земеделска територия с допустима промяна на предназначението.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (155)`,
              color: '#ffc000'
            },
            'MatrixZone#156': {
              sourceTitle: '07079/37 - Земеделска територия с допустима промяна на предназначението. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (156)`,
              color: '#ffc000'
            },

            'MatrixZone#157': {
              sourceTitle: '07079/44 - Територия за изграждане на зоологическа градина. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (157)`,
              color: '#548235'
            },

            'MatrixZone#158': {
              sourceTitle: '07079/60 - Територии за вилни зони. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (158)`,
              color: '#ffff99'
            },

            'MatrixZone#159': {
              sourceTitle: '07079/62 - Територия за възстановяване и рекултивация. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (159)`,
              color: '#008000'
            },

            'MatrixZone#160': {
              sourceTitle: '07079/65 - Земеделска територия с допустима промяна на предназначението. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (160)`,
              color: '#ffc000'
            },

            'MatrixZone#161': {
              sourceTitle: '07079/68 - Територии за вилни зони. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (161)`,
              color: '#ffff99'
            },

            'MatrixZone#162': {
              sourceTitle: '07079/70 - Територия за възстановяване и рекултивация. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (162)`,
              color: '#008000'
            },

            'MatrixZone#163': {
              sourceTitle: '07079/71 - Територии за вилни зони. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (163)`,
              color: '#ffff99'
            },

            'MatrixZone#164': {
              sourceTitle: '07079/72 - Територия с преобладаващи курортни функции.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (164)`,
              color: '#99cc00'
            },

            'MatrixZone#165': {
              sourceTitle: '07079/73 - Територии за вилни зони. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (165)`,
              color: '#ffff99'
            },

            'MatrixZone#166': {
              sourceTitle:
                '07079/74 - Смесена територия с преобладаващо предназначение за обществено обслужване и допълващо за безвредни производства. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (166)`,
              color: '#ff8080'
            },

            'MatrixZone#167': {
              sourceTitle: '07079/76 - Горска територия със започнала процедура по промяна на предназначението.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (167)`,
              color: '#99cc00'
            },

            'MatrixZone#168': {
              sourceTitle:
                '07079/78 - Смесена територия с преобладаващо предназначение за обществено обслужване и допълващо за безвредни производства. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (168)`,
              color: '#ff8080'
            },

            'MatrixZone#169': {
              sourceTitle: '07079/81  - Територии за вилни зони. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (169)`,
              color: '#ffff99'
            },

            'MatrixZone#170': {
              sourceTitle: '07079/82  - Територия с преобладаващи курортни функции. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (170)`,
              color: '#99cc00'
            },

            'MatrixZone#171': {
              sourceTitle: '07079/83 - Територия за рибарско селище. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (171)`,
              color: '#ffff99'
            },
            'MatrixZone#172': {
              sourceTitle: '07079/83а - Територия за рибарско пристанище.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (172)`,
              color: '#ffff99'
            },

            'MatrixZone#173': {
              sourceTitle: '07079/84 - Територии за озеленяване, спорт и атракции. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (173)`,
              color: '#548235'
            },

            'MatrixZone#174': {
              sourceTitle: '07079/85 - Територия с преобладаващи курортни функции.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (174)`,
              color: '#99cc00'
            },

            'MatrixZone#175': {
              sourceTitle: '07079/86 - Петролна база на "Лукойл - Нефтохим"',
              constantSqlWhere: `"MatrixZoneTypeId" IN (175)`,
              color: '#cc99ff'
            },

            'MatrixZone#176': {
              sourceTitle: '07079/89 - Територии за вилни зони. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (176)`,
              color: '#ffff99'
            },
            'MatrixZone#177': {
              sourceTitle: '07079/90 - Територии за вилни зони. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (177)`,
              color: '#ffff99'
            },
            'MatrixZone#178': {
              sourceTitle: '07079/91 - Територии за вилни зони.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (178)`,
              color: '#ffff99'
            },
            'MatrixZone#179': {
              sourceTitle: '07079/92 - Територии за вилни зони.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (179)`,
              color: '#ffff99'
            },

            'MatrixZone#180': {
              sourceTitle: '29427/1 - Земеделска територия с допустима промяна на предназначението.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (180)`,
              color: '#ffbffc'
            },

            'MatrixZone#181': {
              sourceTitle:
                '29427/7 - Смесена територия с преобладаващо предназначение за обществено обслужване и допълващо за безвредни производства.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (181)`,
              color: '#ff8080'
            },

            'MatrixZone#182': {
              sourceTitle: '02573/5 - Земеделска територия с допустима промяна на предназначението. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (182)`,
              color: '#ffbffc'
            },

            'MatrixZone#183': {
              sourceTitle: '02573/9 - Територия с преобладаващи курортни функции. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (183)`,
              color: '#99cc00'
            },
            'MatrixZone#184': {
              sourceTitle: '02753/13 - Територия с преобладаващи курортни функции',
              constantSqlWhere: `"MatrixZoneTypeId" IN (184)`,
              color: '#99cc00'
            },

            'MatrixZone#185': {
              sourceTitle: '02753/14 - Земеделска територия с допустима промяна на предназначението.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (185)`,
              color: '#ffbffc'
            },
            'MatrixZone#186': {
              sourceTitle: '02753/16 - Земеделска територия с допустима промяна на предназначението. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (186)`,
              color: '#ffbffc'
            },
            'MatrixZone#187': {
              sourceTitle: '02573/19 - Земеделска територия с допустима промяна на предназначението. ',
              constantSqlWhere: `"MatrixZoneTypeId" IN (187)`,
              color: '#ffbffc'
            },

            'MatrixZone#188': {
              sourceTitle:
                '02573/20 - Територия за производство на електроенергия от възобновяеми енергийни източници с коефициент на усвояване до 90% от площта на имота - фотоволтаици.',
              constantSqlWhere: `"MatrixZoneTypeId" IN (188)`,
              color: '#cc99ff'
            },

            'MatrixZone#189': {sourceTitle: 'Оо', constantSqlWhere: `"MatrixZoneTypeId" IN (189)`, color: '#cc99ff'},
            MatrixZone: {
              sourceTitle: 'Устройствени зони',
              readOnly: true,
              noLegend: true,
              idField: 'Id',
              z: 2,
              // doNotIdentify: true,
              pseudoViewSchema: {0: ViewSchemaType.None, 5: ViewSchemaType.Vector},
              featureTitle: {
                bg: 'Устройствена зона {MatrixZoneTypeId}'
              },
              vectorRenderer: {
                nomenclature: {
                  field: 'MatrixZoneTypeId',
                  values: {
                    '101': [{stroke: {width: 0}, fill: {color: '#ff9900'}}],
                    '102': [{stroke: {width: 0}, fill: {color: '#ff9900'}}],
                    '103': [{stroke: {width: 0}, fill: {color: '#ff9900'}}],
                    '104': [{stroke: {width: 0}, fill: {color: '#ff9900'}}],
                    '105': [{stroke: {width: 0}, fill: {color: '#ff9900'}}],
                    '106': [{stroke: {width: 0}, fill: {color: '#ff9900'}}],
                    '107': [{stroke: {width: 0}, fill: {color: '#ff9900'}}],
                    '108': [{stroke: {width: 0}, fill: {color: '#ff9900'}}],
                    '109': [{stroke: {width: 0}, fill: {color: '#ff9900'}}],
                    '110': [{stroke: {width: 0}, fill: {color: '#ff9900'}}],
                    '111': [{stroke: {width: 0}, fill: {color: '#ff9900'}}],
                    '112': [{stroke: {width: 0}, fill: {color: '#ff9900'}}],
                    '113': [{stroke: {width: 0}, fill: {color: '#f18484'}}],
                    '114': [{stroke: {width: 0}, fill: {color: '#f18484'}}],
                    '115': [{stroke: {width: 0}, fill: {color: '#f18484'}}],
                    '116': [{stroke: {width: 0}, fill: {color: '#f18484'}}],
                    '117': [{stroke: {width: 0}, fill: {color: '#f18484'}}],
                    '118': [{stroke: {width: 0}, fill: {color: '#f18484'}}],
                    '119': [{stroke: {width: 0}, fill: {color: '#ff8080'}}],
                    '120': [{stroke: {width: 0}, fill: {color: '#ff8080'}}],
                    '121': [{stroke: {width: 0}, fill: {color: '#ff8080'}}],
                    '122': [{stroke: {width: 0}, fill: {color: '#ff8080'}}],
                    '123': [{stroke: {width: 0}, fill: {color: '#996633'}}],
                    '124': [{stroke: {width: 0}, fill: {color: '#339966'}}],
                    '125': [{stroke: {width: 0}, fill: {color: '#ffff99'}}],
                    '126': [{stroke: {width: 0}, fill: {color: '#99cc00'}}],
                    '127': [{stroke: {width: 0}, fill: {color: '#548235'}}],
                    '128': [{stroke: {width: 0}, fill: {color: '#ffc000'}}],
                    '129': [{stroke: {width: 0}, fill: {color: '#cc99ff'}}],
                    '130': [{stroke: {width: 0}, fill: {color: '#cc99ff'}}],
                    '131': [{stroke: {width: 0}, fill: {color: '#cc99ff'}}],
                    '132': [{stroke: {width: 0}, fill: {color: '#f8cbad'}}],
                    '133': [{stroke: {width: 0}, fill: {color: '#ffffff'}}],
                    '134': [{stroke: {width: 0}, fill: {color: '#ff8080'}}],
                    '135': [{stroke: {width: 0}, fill: {color: '#cc99ff'}}],
                    '136': [{stroke: {width: 0}, fill: {color: '#ff8080'}}],
                    '137': [{stroke: {width: 0}, fill: {color: '#ff8080'}}],
                    '138': [{stroke: {width: 0}, fill: {color: '#cc99ff'}}],
                    '139': [{stroke: {width: 0}, fill: {color: '#ffc000'}}],
                    '140': [{stroke: {width: 0}, fill: {color: '#ff8080'}}],
                    '141': [{stroke: {width: 0}, fill: {color: '#ffc000'}}],
                    '142': [{stroke: {width: 0}, fill: {color: '#cc99ff'}}],
                    '143': [{stroke: {width: 0}, fill: {color: '#ffc000'}}],
                    '144': [{stroke: {width: 0}, fill: {color: '#ffc000'}}],
                    '145': [{stroke: {width: 0}, fill: {color: '#ff8080'}}],
                    '146': [{stroke: {width: 0}, fill: {color: '#548235'}}],
                    '147': [{stroke: {width: 0}, fill: {color: '#ff8080'}}],
                    '148': [{stroke: {width: 0}, fill: {color: '#ffc000'}}],
                    '149': [{stroke: {width: 0}, fill: {color: '#ffc000'}}],
                    '150': [{stroke: {width: 0}, fill: {color: '#ffc000'}}],
                    '151': [{stroke: {width: 0}, fill: {color: '#ff8080'}}],
                    '152': [{stroke: {width: 0}, fill: {color: '#ff8080'}}],
                    '153': [{stroke: {width: 0}, fill: {color: '#548235'}}],
                    '154': [{stroke: {width: 0}, fill: {color: '#ffc000'}}],
                    '155': [{stroke: {width: 0}, fill: {color: '#ffc000'}}],
                    '156': [{stroke: {width: 0}, fill: {color: '#ffc000'}}],
                    '157': [{stroke: {width: 0}, fill: {color: '#548235'}}],
                    '158': [{stroke: {width: 0}, fill: {color: '#ffff99'}}],
                    '159': [{stroke: {width: 0}, fill: {color: '#008000'}}],
                    '160': [{stroke: {width: 0}, fill: {color: '#ffc000'}}],
                    '161': [{stroke: {width: 0}, fill: {color: '#ffff99'}}],
                    '162': [{stroke: {width: 0}, fill: {color: '#008000'}}],
                    '163': [{stroke: {width: 0}, fill: {color: '#ffff99'}}],
                    '164': [{stroke: {width: 0}, fill: {color: '#99cc00'}}],
                    '165': [{stroke: {width: 0}, fill: {color: '#ffff99'}}],
                    '166': [{stroke: {width: 0}, fill: {color: '#ff8080'}}],
                    '167': [{stroke: {width: 0}, fill: {color: '#99cc00'}}],
                    '168': [{stroke: {width: 0}, fill: {color: '#ff8080'}}],
                    '169': [{stroke: {width: 0}, fill: {color: '#ffff99'}}],
                    '170': [{stroke: {width: 0}, fill: {color: '#99cc00'}}],
                    '171': [{stroke: {width: 0}, fill: {color: '#ffff99'}}],
                    '172': [{stroke: {width: 0}, fill: {color: '#ffff99'}}],
                    '173': [{stroke: {width: 0}, fill: {color: '#548235'}}],
                    '174': [{stroke: {width: 0}, fill: {color: '#99cc00'}}],
                    '175': [{stroke: {width: 0}, fill: {color: '#cc99ff'}}],
                    '176': [{stroke: {width: 0}, fill: {color: '#ffff99'}}],
                    '177': [{stroke: {width: 0}, fill: {color: '#ffff99'}}],
                    '178': [{stroke: {width: 0}, fill: {color: '#ffff99'}}],
                    '179': [{stroke: {width: 0}, fill: {color: '#ffff99'}}],
                    '180': [{stroke: {width: 0}, fill: {color: '#ffbffc'}}],
                    '181': [{stroke: {width: 0}, fill: {color: '#ff8080'}}],
                    '182': [{stroke: {width: 0}, fill: {color: '#ffbffc'}}],
                    '183': [{stroke: {width: 0}, fill: {color: '#99cc00'}}],
                    '184': [{stroke: {width: 0}, fill: {color: '#99cc00'}}],
                    '185': [{stroke: {width: 0}, fill: {color: '#ffbffc'}}],
                    '186': [{stroke: {width: 0}, fill: {color: '#ffbffc'}}],
                    '187': [{stroke: {width: 0}, fill: {color: '#ffbffc'}}],
                    '188': [{stroke: {width: 0}, fill: {color: '#cc99ff'}}],
                    '189': [{stroke: {width: 0}, fill: {color: '#cc99ff'}}]
                  }
                }
              },
              tableFields: ['MatrixZoneTypeId', 'MatrixConstrType', 'MatrixKint', 'MatrixZoneVariety'],
              fieldInfos: matrixFields
            }
          } as any
        },
        zonelines: {
          layers: {
            Site: {
              sourceTitle: 'Застроителни линии',
              idField: 'ParcelId',
              z: 1,
              noLegend: true,
              minimumz: 10,
              pseudoViewSchema: {0: ViewSchemaType.None, 10: ViewSchemaType.Vector},
              constantSqlWhere: '"OverriddenByRegPlanId" IS NULL',
              featureTitle: {
                bg: 'Застроителна линия на {ParcelNumber}-{CadNumbers}'
              },
              tableFields: ['ParcelNumber', 'CadNumbers'],
              vectorRenderer: {
                def: [
                  {
                    stroke: {
                      color: 'red',
                      width: 2
                    }
                  }
                ]
              },
              fieldInfos: siteParcelFields
            },
            SiteLine: {
              sourceTitle: 'Застроителна линия',
              idField: 'UID',
              z: 9,
              identifyZ: 10,
              readOnly: true,
              minimumz: 10,
              pseudoViewSchema: {0: ViewSchemaType.None, 10: ViewSchemaType.Vector},
              featureTitle: {
                bg: 'Застроителна линия'
              },
              noRegister: true,
              tableFields: ['UID'],
              vectorRenderer: {
                nomenclature: {
                  field: 'LineType',
                  values: {
                    '1': [
                      {
                        stroke: {
                          color: 'red',
                          width: 2
                        }
                      }
                    ],
                    '2': [
                      {
                        stroke: {
                          color: 'red',
                          width: 2,
                          lineDash: [10, 5]
                        }
                      }
                    ],
                    '3': [
                      {
                        stroke: {
                          color: 'gray',
                          width: 2,
                          lineDash: [10, 5]
                        }
                      }
                    ]
                  }
                }
              },
              fieldInfos: {
                Id: {
                  visible: false,
                  editable: false,
                  label: {bg: ''}
                },
                LineType: {
                  visible: true,
                  editable: true,
                  label: {bg: 'Тип линия'},
                  nullable: false,
                  codedValues: [
                    {code: '1', name: 'Задължителна'},
                    {code: '2', name: 'Ограничителна'},
                    {code: '3', name: 'Друга'}
                  ]
                },
                LineNumber: {
                  visible: false,
                  editable: false,
                  label: {bg: ''}
                },
                LineTypes: {
                  visible: false,
                  editable: false,
                  label: {bg: ''}
                }
              }
            },
            ConstrBuilding: {
              sourceTitle: 'Застроителни линии (допълнителни)',
              idField: 'Id',
              hasAttachments: false,
              addOnMap: true,
              visible: true,
              readOnly: false,
              doNotIdentify: false,
              z: 9,
              tableFields: ['H', 'Floors', 'SettlementName', 'QuarterNumber', 'ParcelNumber'],
              pseudoViewSchema: {0: ViewSchemaType.None, 10: ViewSchemaType.Vector},
              minimumz: 10,
              vectorRenderer: {
                nomenclature: {
                  field: 'Type',
                  values: {
                    '0': [
                      {
                        stroke: {
                          color: 'red',
                          width: 1
                        }
                      },
                      {
                        geometry: `var geom = feature.getGeometry();
                                            if(geom && feature.getProperties()['H']){
                                                return geom.getCenter();
                                            }`,
                        text: {
                          textFunction: "feature.get('H') ? 'H: ' + feature.get('H') : ''",
                          fillColor: 'red',
                          offsetX: 0,
                          offsetY: -6,
                          font: '10px sans-serif'
                        },
                        zIndex: 4
                      },
                      {
                        geometry: `var geom = feature.getGeometry();
                                            if(geom && feature.getProperties()['Floors']){
                                                return geom.getCenter();
                                            }`,
                        text: {
                          textFunction: "feature.get('Floors') ? 'ЕТ: ' + feature.get('Floors') : ''",
                          fillColor: 'red',
                          offsetX: 0,
                          offsetY: 6,
                          font: '10px sans-serif'
                        },
                        zIndex: 4
                      }
                    ],
                    '1': [
                      {
                        stroke: {
                          color: 'red',
                          width: 1,
                          lineDash: [7, 3]
                        }
                      },
                      {
                        geometry: `var geom = feature.getGeometry();
                                            if(geom && feature.getProperties()['H']){
                                                return geom.getCenter();
                                            }`,
                        text: {
                          textFunction: "feature.get('H') ? 'H: ' + feature.get('H') : ''",
                          fillColor: 'red',
                          offsetX: 0,
                          offsetY: -6,
                          font: '10px sans-serif'
                        },
                        zIndex: 4
                      },
                      {
                        geometry: `var geom = feature.getGeometry();
                                            if(geom && feature.getProperties()['Floors']){
                                                return geom.getCenter();
                                            }`,
                        text: {
                          textFunction: "feature.get('Floors') ? 'ЕТ: ' + feature.get('Floors') : ''",
                          fillColor: 'red',
                          offsetX: 0,
                          offsetY: 6,
                          font: '10px sans-serif'
                        },
                        zIndex: 4
                      }
                    ]
                  }
                }
              },
              featureTitle: {
                bg: 'Застроителна линия (допълнителна)'
              },
              fieldInfos: {
                EKATTE: {
                  label: {
                    bg: 'EKATTE'
                  },
                  visible: true,
                  editable: false
                },
                SettlementName: {
                  label: {
                    bg: 'Име на населено място'
                  },
                  visible: true,
                  editable: false
                },
                Type: {
                  label: {
                    bg: 'Тип'
                  },
                  visible: true,
                  editable: true,
                  codedValues: [
                    {code: '0', name: 'Задължителна'},
                    {code: '1', name: 'Ограничителна'}
                  ]
                },
                ParcelNumber: {
                  label: {
                    bg: 'Номер'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                CadNumbers: {
                  label: {
                    bg: 'Кадастрални номера'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                ParcelTypeId: {
                  label: {
                    bg: 'Тип парцел'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                //
                H: {
                  label: {
                    bg: 'Височина (м)'
                  },
                  visible: true,
                  editable: true
                },
                Floors: {
                  label: {
                    bg: 'Етажи'
                  },
                  visible: true,
                  editable: true
                },
                QuarterNumber: {
                  label: {
                    bg: 'Квартал номер'
                  },
                  visible: true,
                  editable: false
                },
                ParcelId: {
                  label: {
                    bg: ''
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Locality: {
                  label: {
                    bg: 'Местоположение'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                Created: {
                  visible: false,
                  editable: false,
                  nullable: true,
                  label: {bg: ''}
                },
                CreatedBy: {
                  visible: false,
                  editable: false,
                  nullable: true,
                  label: {bg: ''}
                },
                Modified: {
                  visible: false,
                  editable: false,
                  nullable: true,
                  label: {bg: ''}
                },
                ModifiedBy: {
                  visible: false,
                  editable: false,
                  nullable: true,
                  label: {bg: ''}
                }
              }
            }
          }
        }
      },
      StreetReg: {
        streetreg: {
          layers: {
            StreetRegAreaLine: {
              sourceTitle: 'Затворени полигони',
              idField: 'Id',
              constantSqlWhere: '"OverridenById" IS NULL',
              z: 9,
              identifyZ: 10,
              pseudoViewSchema: {9: ViewSchemaType.Vector},
              featureTitle: {
                bg: ''
              },
              readOnly: true,
              doNotIdentify: true,
              noRegister: true,
              tableFields: ['Id'],
              vectorRenderer: {
                nomenclature: {
                  field: 'AreaLineTypeId',
                  values: {
                    '1': [
                      {
                        stroke: {
                          color: 'red',
                          width: 2
                        }
                      }
                    ],
                    '2': [
                      {
                        stroke: {
                          color: 'red',
                          width: 2,
                          lineDash: [7, 3]
                        }
                      }
                    ]
                  }
                }
              },
              fieldInfos: {
                Id: {
                  visible: false,
                  editable: false,
                  label: {bg: ''}
                },
                AreaLineTypeId: {
                  visible: true,
                  editable: true,
                  label: {bg: 'Тип линия'},
                  nullable: false,
                  codedValues: [
                    {code: '1', name: 'Квартална регулация'},
                    {code: '2', name: 'Ограничителен пунктир'}
                  ]
                },
                Created: {
                  visible: false,
                  editable: false,
                  nullable: true,
                  label: {bg: ''}
                },
                CreatedBy: {
                  visible: false,
                  editable: false,
                  nullable: true,
                  label: {bg: ''}
                },
                Modified: {
                  visible: false,
                  editable: false,
                  nullable: true,
                  label: {bg: ''}
                },
                ModifiedBy: {
                  visible: false,
                  editable: false,
                  nullable: true,
                  label: {bg: ''}
                }
              }
            },
            StreetRegArea: {
              sourceTitle: 'Затворени полигони',
              idField: 'Id',
              constantSqlWhere: '"OverridenById" IS NULL',
              z: 9,
              identifyZ: 10,
              pseudoViewSchema: {0: ViewSchemaType.TileImage},
              featureTitle: {
                bg: 'Ул. рег. затворен полигон'
              },
              opacity: 1,
              hasAttachments: true,
              readOnly: false,
              noLegend: true,
              tableFields: ['LocName', 'PlanName', 'PlanDate'],
              fieldInfos: {
                Id: {
                  visible: false,
                  editable: false,
                  nullable: true,
                  label: {bg: ''}
                },

                SettlementName: {
                  visible: true,
                  editable: false,
                  nullable: true,
                  label: {bg: 'Населено място'}
                },
                LocName: {
                  visible: true,
                  editable: false,
                  nullable: true,
                  label: {bg: 'Местност'}
                },
                Description: {
                  visible: true,
                  editable: true,
                  nullable: true,
                  length: 4000,
                  label: {bg: 'Забележка'}
                },
                PlanName: {
                  visible: true,
                  editable: false,
                  nullable: true,
                  label: {bg: 'Име на плана'}
                },
                PlanDate: {
                  visible: true,
                  editable: false,
                  nullable: true,
                  label: {bg: 'Дата на плана'},
                  dateFormat: 'dd.MM.yyyy'
                },

                Points: {
                  visible: true,
                  editable: false,
                  nullable: true,
                  label: {bg: 'Осови точки'}
                },
                RegPlanId: {
                  visible: false,
                  editable: false,
                  nullable: true,
                  label: {bg: ''}
                },
                OverridenById: {
                  visible: false,
                  editable: false,
                  nullable: true,
                  label: {bg: ''}
                },
                Created: {
                  visible: false,
                  editable: false,
                  nullable: true,
                  label: {bg: ''}
                },
                CreatedBy: {
                  visible: false,
                  editable: false,
                  nullable: true,
                  label: {bg: ''}
                },
                Modified: {
                  visible: false,
                  editable: false,
                  nullable: true,
                  label: {bg: ''}
                },
                ModifiedBy: {
                  visible: false,
                  editable: false,
                  nullable: true,
                  label: {bg: ''}
                }
              }
            },
            StreetRegPlan: {
              sourceTitle: 'Затворени полигони',
              idField: 'Id',
              constantSqlWhere: '"OverridenById" IS NULL',
              z: 9,
              identifyZ: 10,
              pseudoViewSchema: {0: ViewSchemaType.None},
              featureTitle: {
                bg: ''
              },
              doNotIdentify: true,
              opacity: 1,
              readOnly: true,
              noLegend: true,
              noRegister: true,
              tableFields: ['Id'],
              fieldInfos: {
                Id: {
                  visible: false,
                  editable: false,
                  label: {bg: ''}
                }
              }
            },
            StreetRegOsLine: {
              sourceTitle: 'Осови линии',
              idField: 'Id',
              z: 9,
              readOnly: true,
              doNotIdentify: true,
              noRegister: true,
              pseudoViewSchema: {16: ViewSchemaType.Vector},
              constantSqlWhere: '"OverridenById" IS NULL',
              featureTitle: {
                bg: 'Осова линия'
              },
              vectorRenderer: {
                def: [
                  {
                    stroke: {
                      color: 'red',
                      width: 1,
                      lineDash: [9, 5, 2, 5]
                    }
                  }
                ]
              },
              fieldInfos: {
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            StreetRegLine: {
              sourceTitle: 'Бордюрна линия',
              idField: 'Id',
              z: 9,
              pseudoViewSchema: {16: ViewSchemaType.Vector},
              constantSqlWhere: '"OverridenById" IS NULL',
              readOnly: true,
              doNotIdentify: true,
              noRegister: true,
              featureTitle: {
                bg: 'Бордюрна линия'
              },
              vectorRenderer: {
                def: [
                  {
                    stroke: {
                      color: 'rgba(0, 127, 255, 1)',
                      width: 1
                    }
                  }
                ]
              },
              fieldInfos: {
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            StreetRegPoint: {
              sourceTitle: 'Осови точки',
              idField: 'Id',
              z: 9,
              readOnly: true,
              doNotIdentify: true,
              noRegister: true,
              pseudoViewSchema: {16: ViewSchemaType.Vector},
              constantSqlWhere: '"OverridenById" IS NULL',
              featureTitle: {
                bg: 'Осова точка'
              },
              vectorRenderer: {
                def: [
                  {
                    circle: {
                      radius: 5,
                      stroke: {
                        width: 1,
                        color: 'red'
                      }
                    },
                    text: {
                      textFunction: `feature.getProperties()['Number'] || ''`,
                      fillColor: 'red',
                      offsetX: 15,
                      offsetY: 0,
                      font: '12px sans-serif'
                    }
                  },
                  {
                    circle: {
                      radius: 1,
                      stroke: {
                        width: 0,
                        color: 'red'
                      },
                      fill: {
                        color: 'red'
                      }
                    }
                  }
                ]
              },
              fieldInfos: {
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            }
          }
        }
      },
      Misc: {
        misc: {
          layers: {
            MiscLine: {
              sourceTitle: 'Кадастрален план - Линии',
              idField: 'Id',
              z: 8,
              featureTitle: {
                bg: 'Кадастрален план - Линии'
              },
              pseudoViewSchema: {14: ViewSchemaType.TileImage},
              tableFields: ['Id', 'Description', 'MiscLineTypeId', 'LocalityId', 'Created'],
              readOnly: false,
              addOnMap: true,
              fieldInfos: {
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },

                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Id: {
                  label: {
                    bg: 'Входящ номер'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                MiscLineTypeId: {
                  label: {
                    bg: 'Тип'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                LocalityId: {
                  label: {
                    bg: 'Местоположение'
                  },
                  visible: false,
                  editable: false,
                  nullable: false
                },
                Description: {
                  label: {
                    bg: 'Описание'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                }
              }
            },
            MiscPoint: {
              sourceTitle: 'Кадастрален план - Точкови обекти',
              idField: 'Id',
              z: 8,
              featureTitle: {
                bg: 'Кадастрален план - Точкови обекти'
              },
              pseudoViewSchema: {0: ViewSchemaType.None, 14: ViewSchemaType.TileImage},
              tableFields: ['Id', 'Description', 'MiscPointTypeId', 'LocalityId', 'Created'],
              readOnly: false,
              addOnMap: true,

              fieldInfos: {
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },

                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Id: {
                  label: {
                    bg: 'Входящ номер'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                MiscPointTypeId: {
                  label: {
                    bg: 'Тип'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                LocalityId: {
                  label: {
                    bg: 'Местоположение'
                  },
                  visible: false,
                  editable: true,
                  nullable: false
                }
              }
            },
            Visas: {
              sourceTitle: 'Визи',
              idField: 'Id',
              z: 8,
              featureTitle: {
                bg: 'Визи'
              },
              pseudoViewSchema: {14: ViewSchemaType.TileImage},
              tableFields: ['Id', 'Description', 'LocalityId', 'Created'],
              readOnly: false,
              addOnMap: true,
              fieldInfos: {
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },

                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Id: {
                  label: {
                    bg: 'Входящ номер'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                MiscLineTypeId: {
                  label: {
                    bg: 'Тип'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                LocalityId: {
                  label: {
                    bg: 'Местоположение'
                  },
                  visible: false,
                  editable: false,
                  nullable: false
                },
                Description: {
                  label: {
                    bg: 'Описание/Текст'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                MiscColorId: {
                  label: {
                    bg: 'Цвят'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                MiscTypeId: {
                  label: {
                    bg: 'Тип'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                MiscVisibleTextId: {
                  label: {
                    bg: 'Видим текст'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                }
              }
            },
            MovableObjects: {
              sourceTitle: 'Преместваеми обекти',
              idField: 'Id',
              z: 8,
              featureTitle: {
                bg: 'Преместваеми обекти'
              },
              pseudoViewSchema: {14: ViewSchemaType.TileImage},
              tableFields: ['Id', 'Description', 'LocalityId', 'Created'],
              readOnly: false,
              addOnMap: true,
              fieldInfos: {
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },

                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Id: {
                  label: {
                    bg: 'Входящ номер'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                MiscLineTypeId: {
                  label: {
                    bg: 'Тип'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                LocalityId: {
                  label: {
                    bg: 'Местоположение'
                  },
                  visible: false,
                  editable: false,
                  nullable: false
                },
                Description: {
                  label: {
                    bg: 'Описание/Текст'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                MiscColorId: {
                  label: {
                    bg: 'Цвят'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                MiscTypeId: {
                  label: {
                    bg: 'Тип'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                MiscVisibleTextId: {
                  label: {
                    bg: 'Видим текст'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                }
              }
            }
          }
        }
      },
      OUP: {
        oup: {
          layers: {
            LandCategory: {
              sourceTitle: 'Схема на земеделската територия по категории',
              idField: 'Id',
              z: 0,
              minimumz: 0,
              opacity: 10,
              noRegister: true,
              readOnly: true,
              pseudoViewSchema: {15: ViewSchemaType.TileImage},
              featureTitle: {
                bg: 'Категория {desc}'
              },
              doNotIdentify: false,
              tableFields: ['desc'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                desc: {
                  label: {
                    bg: 'Описание'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                ekatte: {
                  label: {
                    bg: 'EKATTE'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            Ecology: {
              sourceTitle: 'Схема на екологичното състояние',
              idField: 'Id',
              z: 0,
              minimumz: 0,
              opacity: 10,
              noRegister: true,
              readOnly: true,
              pseudoViewSchema: {15: ViewSchemaType.TileImage},
              featureTitle: {
                bg: 'Категория {desc}'
              },
              doNotIdentify: false,
              tableFields: ['desc'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                desc: {
                  label: {
                    bg: 'Описание'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                ekatte: {
                  label: {
                    bg: 'EKATTE'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            Zone: {
              sourceTitle: 'ОУП Зони',
              idField: 'Id',
              z: 1,
              minimumz: 0,
              opacity: 20,
              pseudoViewSchema: {10: ViewSchemaType.TileImage},
              vectorRenderer: {
                nomenclature: {
                  field: 'developmentzone',
                  values: {
                    '3': [
                      {
                        fill: {
                          color: 'rgb(180 81 48)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '4': [
                      {
                        fill: {
                          color: 'rgb(180 81 48)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '5': [
                      {
                        fill: {
                          color: 'rgb(180 81 48)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '6': [
                      {
                        fill: {
                          color: 'rgb(252 189 31)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '7': [
                      {
                        fill: {
                          color: 'rgb(252 189 31)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '8': [
                      {
                        fill: {
                          color: 'rgb(252 189 31)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '9': [
                      {
                        fill: {
                          color: 'rgb(252 189 31)'
                        },
                        stroke: {
                          color: 'rgb(64 130 54)'
                        }
                      }
                    ],
                    '10': [
                      {
                        fill: {
                          color: 'rgb(64 130 54)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '11': [
                      {
                        fill: {
                          color: 'rgb(64 130 54)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '12': [
                      {
                        fill: {
                          color: 'rgb(64 130 54)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '13': [
                      {
                        fill: {
                          color: 'rgb(99 61 156)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '14': [
                      {
                        fill: {
                          color: 'rgb(99 61 156)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '15': [
                      {
                        fill: {
                          color: 'rgb(99 61 156)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '16': [
                      {
                        fill: {
                          color: 'rgb(213 184 242)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '17': [
                      {
                        fill: {
                          color: 'rgb(99 61 156)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '18': [
                      {
                        fill: {
                          color: 'rgb(220 44 39)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '19': [
                      {
                        fill: {
                          color: 'rgb(220 44 39)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '20': [
                      {
                        fill: {
                          color: 'rgb(220 44 39)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '21': [
                      {
                        fill: {
                          color: 'rgb(180 81 48)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '22': [
                      {
                        fill: {
                          color: 'rgb(189 154 122)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '23': [
                      {
                        fill: {
                          color: 'rgb(180 81 48)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '24': [
                      {
                        fill: {
                          color: 'rgb(237 14 14)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '25': [
                      {
                        fill: {
                          color: 'rgb(234,142,141)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '26': [
                      {
                        fill: {
                          color: 'rgb(189 154 122)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ]
                  }
                }
              },
              featureTitle: {
                bg: 'ОУП Зона {devzonetype}'
              },
              doNotIdentify: false,
              tableFields: ['devzonetype'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                developmentzone: {
                  label: {
                    bg: 'Зона тип'
                  },
                  visible: true,
                  editable: true,
                  nullable: true,
                  codedValues: [
                    {code: 3, name: 'Жг'},
                    {code: 4, name: 'Жм'},
                    {code: 5, name: 'Жс'},
                    {code: 6, name: 'Зтп'},
                    {code: 7, name: 'Зтп1'},
                    {code: 8, name: 'Зтп2'},
                    {code: 9, name: 'Ов'},
                    {code: 10, name: 'Од'},
                    {code: 11, name: 'Оз'},
                    {code: 12, name: 'Ок'},
                    {code: 13, name: 'Пп'},
                    {code: 14, name: 'Пс'},
                    {code: 15, name: 'Пч'},
                    {code: 16, name: 'Смф'},
                    {code: 17, name: 'Смф1'},
                    {code: 18, name: 'Ц'},
                    {code: 19, name: 'Ц1'},
                    {code: 20, name: 'Ц2'},
                    {code: 21, name: 'Жк'},
                    {code: 22, name: 'Жв'},
                    {code: 23, name: 'Атр'},
                    {code: 24, name: 'Oo'},
                    {code: 25, name: 'О'},
                    {code: 26, name: 'Ниви'},
                    {code: 27, name: 'Tрайни насаждения'},

                    {code: 97, name: 'Сметища и депа за отпадъци'},
                    {code: 98, name: 'Тгп'},
                    {code: 99, name: 'Водни площи'}
                  ]
                },
                developmentzone_decs: {
                  label: {
                    bg: 'Описание'
                  },
                  visible: true,
                  editable: true
                },
                numberzone: {
                  label: {
                    bg: 'Номер'
                  },
                  visible: true,
                  editable: true
                },
                numberzone_desc: {
                  label: {
                    bg: 'Номер - описание'
                  },
                  visible: true,
                  editable: true
                },
                ekkate: {
                  label: {
                    bg: 'ЕКАТТЕ'
                  },
                  visible: true,
                  editable: true
                },
                devzonetype: {
                  label: {
                    bg: 'devzonetype'
                  },
                  visible: true,
                  editable: true,
                  codedValues: [
                    {code: 1, name: '1'},
                    {code: 2, name: '2'}
                  ]
                },
                buildingdensity: {
                  label: {
                    bg: 'Плътност на застрояване'
                  },
                  visible: true,
                  editable: true
                },
                buildingdensity_desc: {
                  label: {
                    bg: 'Плътност на застрояване описание'
                  },
                  visible: true,
                  editable: true
                },
                minbuildingdensity: {
                  label: {
                    bg: 'Минимална плътност'
                  },
                  visible: true,
                  editable: true
                },
                maxbuildingdensity: {
                  label: {
                    bg: 'Максимална плътност'
                  },
                  visible: true,
                  editable: true
                },
                kint: {
                  label: {
                    bg: 'КИНТ'
                  },
                  visible: true,
                  editable: true
                },
                kint_desc: {
                  label: {
                    bg: 'КИНТ описание'
                  },
                  visible: true,
                  editable: true
                },
                minkint: {
                  label: {
                    bg: 'мин КИНТ'
                  },
                  visible: true,
                  editable: true
                },
                maxkint: {
                  label: {
                    bg: 'макс КИНТ'
                  },
                  visible: true,
                  editable: true
                },
                floor: {
                  label: {
                    bg: 'Етаж'
                  },
                  visible: true,
                  editable: true
                },
                height: {
                  label: {
                    bg: 'Височина'
                  },
                  visible: true,
                  editable: true
                },
                flloor_height_desc: {
                  label: {
                    bg: 'Етажност описание'
                  },
                  visible: true,
                  editable: true
                },
                mingreenarea: {
                  label: {
                    bg: 'Мин. озел. площ'
                  },
                  visible: true,
                  editable: true
                },
                maxmingreenarea: {
                  label: {
                    bg: 'Макс. озел. площ'
                  },
                  visible: true,
                  editable: true
                },
                mingreenarea_desc: {
                  label: {
                    bg: 'Мин озел площ описание'
                  },
                  visible: true,
                  editable: true
                },
                desc: {
                  label: {
                    bg: 'Описание'
                  },
                  visible: true,
                  editable: true
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            Project: {
              sourceTitle: 'Проектни Зони',
              idField: 'Id',
              z: 0,
              minimumz: 0,
              opacity: 20,
              pseudoViewSchema: {10: ViewSchemaType.TileImage},
              vectorRenderer: {
                nomenclature: {
                  field: 'developmentzone',
                  values: {
                    '21': [
                      {
                        fill: {
                          color: 'rgb(180 81 48)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '22': [
                      {
                        fill: {
                          color: 'rgb(189 154 122)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '23': [
                      {
                        fill: {
                          color: 'rgb(180 81 48)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '24': [
                      {
                        fill: {
                          color: 'rgb(237 14 14)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '25': [
                      {
                        fill: {
                          color: 'rgb(180 81 48)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '26': [
                      {
                        fill: {
                          color: 'rgb(189 154 122)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '3': [
                      {
                        fill: {
                          color: 'rgb(180 81 48)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '4': [
                      {
                        fill: {
                          color: 'rgb(180 81 48)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '5': [
                      {
                        fill: {
                          color: 'rgb(180 81 48)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '6': [
                      {
                        fill: {
                          color: 'rgb(252 189 31)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '7': [
                      {
                        fill: {
                          color: 'rgb(252 189 31)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '8': [
                      {
                        fill: {
                          color: 'rgb(252 189 31)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '9': [
                      {
                        fill: {
                          color: 'rgb(252 189 31)'
                        },
                        stroke: {
                          color: 'rgb(64 130 54)'
                        }
                      }
                    ],
                    '10': [
                      {
                        fill: {
                          color: 'rgb(64 130 54)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '11': [
                      {
                        fill: {
                          color: 'rgb(64 130 54)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '12': [
                      {
                        fill: {
                          color: 'rgb(64 130 54)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '13': [
                      {
                        fill: {
                          color: 'rgb(99 61 156)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '14': [
                      {
                        fill: {
                          color: 'rgb(99 61 156)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '15': [
                      {
                        fill: {
                          color: 'rgb(99 61 156)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '16': [
                      {
                        fill: {
                          color: 'rgb(213 184 242)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '17': [
                      {
                        fill: {
                          color: 'rgb(99 61 156)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '18': [
                      {
                        fill: {
                          color: 'rgb(220 44 39)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '19': [
                      {
                        fill: {
                          color: 'rgb(220 44 39)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '20': [
                      {
                        fill: {
                          color: 'rgb(220 44 39)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ]
                  }
                }
              },
              featureTitle: {
                bg: 'Зона {devzonetype}'
              },
              doNotIdentify: false,
              tableFields: ['devzonetype'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                developmentzone: {
                  label: {
                    bg: 'Зона тип'
                  },
                  visible: true,
                  editable: true,
                  nullable: true,
                  codedValues: [
                    {code: 3, name: 'Жг'},
                    {code: 4, name: 'Жм'},
                    {code: 5, name: 'Жс'},
                    {code: 6, name: 'Зтп'},
                    {code: 7, name: 'Зтп1'},
                    {code: 8, name: 'Зтп2'},
                    {code: 9, name: 'Ов'},
                    {code: 10, name: 'Од'},
                    {code: 11, name: 'Оз'},
                    {code: 12, name: 'Ок'},
                    {code: 13, name: 'Пп'},
                    {code: 14, name: 'Пс'},
                    {code: 15, name: 'Пч'},
                    {code: 16, name: 'Смф'},
                    {code: 17, name: 'Смф1'},
                    {code: 18, name: 'Ц'},
                    {code: 19, name: 'Ц1'},
                    {code: 20, name: 'Ц2'},
                    {code: 21, name: 'Жк'},
                    {code: 22, name: 'Жв'},
                    {code: 23, name: 'Атр'},
                    {code: 24, name: 'Oo'},
                    {code: 99, name: 'Натура 2000'}
                  ]
                },
                developmentzone_decs: {
                  label: {
                    bg: 'Описание'
                  },
                  visible: true,
                  editable: true
                },
                numberzone: {
                  label: {
                    bg: 'Номер'
                  },
                  visible: true,
                  editable: true
                },
                numberzone_desc: {
                  label: {
                    bg: 'Номер - описание'
                  },
                  visible: true,
                  editable: true
                },
                ekkate: {
                  label: {
                    bg: 'ЕКАТТЕ'
                  },
                  visible: true,
                  editable: true
                },
                devzonetype: {
                  label: {
                    bg: 'devzonetype'
                  },
                  visible: true,
                  editable: true,
                  codedValues: [
                    {code: 1, name: '1'},
                    {code: 2, name: '2'}
                  ]
                },
                buildingdensity: {
                  label: {
                    bg: 'buildingdensity'
                  },
                  visible: true,
                  editable: true
                },
                buildingdensity_desc: {
                  label: {
                    bg: 'buildingdensity_desc'
                  },
                  visible: true,
                  editable: true
                },
                minbuildingdensity: {
                  label: {
                    bg: 'minbuildingdensity'
                  },
                  visible: true,
                  editable: true
                },
                maxbuildingdensity: {
                  label: {
                    bg: 'maxbuildingdensity'
                  },
                  visible: true,
                  editable: true
                },
                kint: {
                  label: {
                    bg: 'КИНТ'
                  },
                  visible: true,
                  editable: true
                },
                kint_desc: {
                  label: {
                    bg: 'КИНТ описание'
                  },
                  visible: true,
                  editable: true
                },
                minkint: {
                  label: {
                    bg: 'мин КИНТ'
                  },
                  visible: true,
                  editable: true
                },
                maxkint: {
                  label: {
                    bg: 'макс КИНТ'
                  },
                  visible: true,
                  editable: true
                },
                floor: {
                  label: {
                    bg: 'Етаж'
                  },
                  visible: true,
                  editable: true
                },
                height: {
                  label: {
                    bg: 'Височина'
                  },
                  visible: true,
                  editable: true
                },
                flloor_height_desc: {
                  label: {
                    bg: 'Етажност описание'
                  },
                  visible: true,
                  editable: true
                },
                mingreenarea: {
                  label: {
                    bg: 'Мин. озел. площ'
                  },
                  visible: true,
                  editable: true
                },
                maxmingreenarea: {
                  label: {
                    bg: 'Макс. озел. площ'
                  },
                  visible: true,
                  editable: true
                },
                mingreenarea_desc: {
                  label: {
                    bg: 'Мин озел площ описание'
                  },
                  visible: true,
                  editable: true
                },
                desc: {
                  label: {
                    bg: 'Описание'
                  },
                  visible: true,
                  editable: true
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            Natura: {
              sourceTitle: 'Натура 2000',
              idField: 'Id',
              z: 2,
              minimumz: 0,
              opacity: 20,
              noRegister: true,
              readOnly: true,
              pseudoViewSchema: {10: ViewSchemaType.TileImage},
              vectorRenderer: {
                nomenclature: {
                  field: 'sitecode',
                  values: {
                    '21': [
                      {
                        fill: {
                          color: 'rgb(180 81 48)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '22': [
                      {
                        fill: {
                          color: 'rgb(189 154 122)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ],
                    '23': [
                      {
                        fill: {
                          color: 'rgb(180 81 48)'
                        },
                        stroke: {
                          color: 'rgba(0,0,0,0)'
                        }
                      }
                    ]
                  }
                }
              },
              featureTitle: {
                bg: 'Зона {sitecode}'
              },
              doNotIdentify: false,
              tableFields: ['sitecode'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                sitetype: {
                  label: {
                    bg: 'Тип'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  codedValues: [
                    {code: 'A', name: 'По директива за птиците'},
                    {code: 'B', name: 'По директива за местообитанията'},
                    {code: 'C', name: 'По директива за местообитанията и птиците'}
                  ]
                },
                sitecode: {
                  label: {
                    bg: 'Код'
                  },
                  visible: true,
                  editable: false
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            Objects: {
              sourceTitle: 'Обекти',
              idField: 'Id',
              z: 2,
              minimumz: 0,
              opacity: 20,
              noRegister: true,
              readOnly: true,
              pseudoViewSchema: {10: ViewSchemaType.TileImage},
              featureTitle: {
                bg: 'Обекти {desc}'
              },
              doNotIdentify: false,
              tableFields: ['desc'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                desc: {
                  label: {
                    bg: 'Описание'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                ekatte: {
                  label: {
                    bg: 'EKATTE'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            Electro: {
              sourceTitle: 'Схема Електричество',
              idField: 'Id',
              z: 2,
              minimumz: 0,
              opacity: 20,
              noRegister: true,
              readOnly: true,
              pseudoViewSchema: {10: ViewSchemaType.TileImage},
              featureTitle: {
                bg: '{desc}'
              },
              doNotIdentify: false,
              tableFields: ['desc'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                desc: {
                  label: {
                    bg: 'Описание'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                ekatte: {
                  label: {
                    bg: 'EKATTE'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            VIK: {
              sourceTitle: 'Схема ВиК',
              idField: 'Id',
              z: 2,
              minimumz: 0,
              opacity: 20,
              noRegister: true,
              readOnly: true,
              pseudoViewSchema: {10: ViewSchemaType.TileImage},
              featureTitle: {
                bg: '{desc}'
              },
              doNotIdentify: false,
              tableFields: ['desc'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                desc: {
                  label: {
                    bg: 'Описание'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                ekatte: {
                  label: {
                    bg: 'EKATTE'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            Transport: {
              sourceTitle: 'Схема Транспортна инфраструктура',
              idField: 'Id',
              z: 2,
              minimumz: 0,
              opacity: 20,
              noRegister: true,
              readOnly: true,
              pseudoViewSchema: {10: ViewSchemaType.TileImage},
              featureTitle: {
                bg: '{desc}'
              },
              doNotIdentify: false,
              tableFields: ['desc'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                desc: {
                  label: {
                    bg: 'Описание'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                ekatte: {
                  label: {
                    bg: 'EKATTE'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            Utils: {
              sourceTitle: 'Схема продуктопроводи',
              idField: 'Id',
              z: 2,
              minimumz: 0,
              opacity: 20,
              noRegister: true,
              readOnly: true,
              pseudoViewSchema: {10: ViewSchemaType.TileImage},
              featureTitle: {
                bg: '{desc}'
              },
              doNotIdentify: false,
              tableFields: ['desc'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                desc: {
                  label: {
                    bg: 'Описание'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                ekatte: {
                  label: {
                    bg: 'EKATTE'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            }
          }
        }
      },
      UND: {
        und: {
          layers: {
            Duct: {
              sourceTitle: 'Проводи',
              idField: 'Id',
              z: 8,
              featureTitle: {
                bg: 'Провод: {Name}'
              },
              pseudoViewSchema: {10: ViewSchemaType.Vector},
              tableFields: ['Name'],
              fieldInfos: {
                DuctTypeId: {
                  label: {
                    bg: 'Вид подземен обект'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                Starth: {
                  label: {
                    bg: 'Надморска височина на начална точка'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Endh: {
                  label: {
                    bg: 'Надморска височина на крайна точка'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Depth: {
                  label: {
                    bg: 'Дълбочина в метри'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                YearBuilt: {
                  label: {
                    bg: 'Година на построяване'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                BuilderId: {
                  label: {
                    bg: 'ЕГН/БУЛСТАТ Строител'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                OwnerId: {
                  label: {
                    bg: 'ЕГН/БУЛСТАТ Собственик'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                UserId: {
                  label: {
                    bg: 'ЕГН/БУЛСТАТ Ползвател'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Name: {
                  label: {
                    bg: 'Име'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                Notes: {
                  label: {
                    bg: 'Информация'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                YearBuild: {
                  label: {
                    bg: 'Година на построяване'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                PreviousId: {
                  label: {
                    bg: 'PreviousId'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                SettlementId: {
                  label: {
                    bg: 'НАСЕЛЕНО МЯСТО'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CadHeight: {
                  label: {
                    bg: 'Надморска височина от кадастъра'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Created: {
                  label: {
                    bg: 'СЪЗДАДЕНО НА'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                Modified: {
                  label: {
                    bg: 'ПРОМЕНЕНО НА'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                CreatedBy: {
                  label: {
                    bg: 'СЪЗДАДЕНО ОТ'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'ПРОМЕНЕНО ОТ'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                Geometry: {
                  label: {
                    bg: 'Geometry'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            PowerLine: {
              sourceTitle: 'Електропроводи',
              idField: 'Id',
              z: 8,
              featureTitle: {
                bg: 'Електропровод: {Name}'
              },
              pseudoViewSchema: {10: ViewSchemaType.Vector},
              tableFields: ['Name'],
              fieldInfos: {
                PowerLineTypeId: {
                  label: {
                    bg: 'Тип електропровод'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                Voltage: {
                  label: {
                    bg: 'Напрежение в KV'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                CablesNumber: {
                  label: {
                    bg: 'Брой кабели'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                TubesNumber: {
                  label: {
                    bg: 'Брой цеви'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                PipeLayingTypeId: {
                  label: {
                    bg: 'Тип електропровод'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                Notes: {
                  label: {
                    bg: 'Забележки'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Name: {
                  label: {
                    bg: 'Име'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                YearBuild: {
                  label: {
                    bg: 'Година на построяване'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                PreviousId: {
                  label: {
                    bg: 'PreviousId'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                SettlementId: {
                  label: {
                    bg: 'НАСЕЛЕНО МЯСТО'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CadHeight: {
                  label: {
                    bg: 'Надморска височина от кадастъра'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                ModelDescription: {
                  label: {
                    bg: 'Описание на модела'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Created: {
                  label: {
                    bg: 'СЪЗДАДЕНО НА'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                Modified: {
                  label: {
                    bg: 'ПРОМЕНЕНО НА'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                CreatedBy: {
                  label: {
                    bg: 'СЪЗДАДЕНО ОТ'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'ПРОМЕНЕНО ОТ'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                Geometry: {
                  label: {
                    bg: 'Geometry'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            ProductPipeline: {
              sourceTitle: 'Продуктопроводи',
              idField: 'Id',
              z: 8,
              featureTitle: {
                bg: 'Продуктопровод: {Name}'
              },
              pseudoViewSchema: {10: ViewSchemaType.Vector},
              tableFields: ['Name'],
              fieldInfos: {
                ProductPipelineTypeId: {
                  label: {
                    bg: 'Вид подземен продуктопровод'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                ProductPipelineMaterialTypeId: {
                  label: {
                    bg: 'Материал'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                InnerDiameter: {
                  label: {
                    bg: 'Диаметър мм'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                PipesNumber: {
                  label: {
                    bg: 'Брой тръби'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                OuterDiameter: {
                  label: {
                    bg: 'Външен Диаметър'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                YearBuild: {
                  label: {
                    bg: 'ГОДИНА НА ПОСТРОЯВАНЕ'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Distance: {
                  label: {
                    bg: 'Разстояние между тръбите'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Thickness: {
                  label: {
                    bg: 'Дебелина'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                PreviousId: {
                  label: {
                    bg: 'PreviousId'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Pressure: {
                  label: {
                    bg: 'Налягане MPa'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                ProductPipelineShapeTypeId: {
                  label: {
                    bg: 'ФОРМА'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                PipeLayingTypeId: {
                  label: {
                    bg: 'НАЧИН НА ПОЛАГАНЕ'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                ProductPipelinePurposeTypeId: {
                  label: {
                    bg: 'ПРЕДНАЗНАЧЕНИЕ'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                Notes: {
                  label: {
                    bg: 'ЗАБЕЛЕЖКИ'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Name: {
                  label: {
                    bg: 'ИМЕ'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                SettlementId: {
                  label: {
                    bg: 'НАСЕЛЕНО МЯСТО'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CadHeight: {
                  label: {
                    bg: 'Надморска височина от кадастъра'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Created: {
                  label: {
                    bg: 'СЪЗДАДЕНО НА'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                Modified: {
                  label: {
                    bg: 'ПРОМЕНЕНО НА'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                CreatedBy: {
                  label: {
                    bg: 'СЪЗДАДЕНО ОТ'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'ПРОМЕНЕНО ОТ'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                Geometry: {
                  label: {
                    bg: 'Geometry'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            Shaft: {
              sourceTitle: 'Шахти',
              idField: 'Id',
              z: 8,
              featureTitle: {
                bg: 'Шахта: {Name}'
              },
              pseudoViewSchema: {10: ViewSchemaType.Vector},
              tableFields: ['Name'],
              fieldInfos: {
                ShaftTypeId: {
                  label: {
                    bg: 'Вид подземен обект'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                CoverHeight: {
                  label: {
                    bg: 'Надморска височина на капака'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                BottomHeight: {
                  label: {
                    bg: 'Надморска височина на дъното'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Depth: {
                  label: {
                    bg: 'Дълбочина в метри'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                DrawingNumber: {
                  label: {
                    bg: 'Скица'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                CarnetNumber: {
                  label: {
                    bg: 'Карнет'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                CarnetPage: {
                  label: {
                    bg: 'Страница на карнет'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                PlanNumber: {
                  label: {
                    bg: 'Планов лист'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                YearBuild: {
                  label: {
                    bg: 'ГОДИНА НА ПОСТРОЯВАНЕ'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                BuilderID: {
                  label: {
                    bg: 'ЕГН/БУЛСТАТ Строител'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                OwnedId: {
                  label: {
                    bg: 'ЕГН/БУЛСТАТ на собственика'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                UserId: {
                  label: {
                    bg: 'ЕГН/БУЛСТАТ на ползвателя'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                ShaftConstructionTypeId: {
                  label: {
                    bg: 'Конструкция'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                Width: {
                  label: {
                    bg: 'Ширина в см'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                Length: {
                  label: {
                    bg: 'Дължина в см'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                ShaftConditionId: {
                  label: {
                    bg: 'Състояние'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                ShaftCoverTypeId: {
                  label: {
                    bg: 'Вид капак'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                ShaftCoverShapeTypeId: {
                  label: {
                    bg: 'Форма на капака'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                CoverWidth: {
                  label: {
                    bg: 'Ширина на капака в см'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                CoverLength: {
                  label: {
                    bg: 'Дължина на капака см'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                Notes: {
                  label: {
                    bg: 'ЗАБЕЛЕЖКИ'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                PreviousId: {
                  label: {
                    bg: 'PreviousId'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Name: {
                  label: {
                    bg: 'ИМЕ'
                  },
                  visible: true,
                  editable: true,
                  nullable: false
                },
                SettlementId: {
                  label: {
                    bg: 'НАСЕЛЕНО МЯСТО'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Created: {
                  label: {
                    bg: 'СЪЗДАДЕНО НА'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                Modified: {
                  label: {
                    bg: 'ПРОМЕНЕНО НА'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                CreatedBy: {
                  label: {
                    bg: 'СЪЗДАДЕНО ОТ'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'ПРОМЕНЕНО ОТ'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                Geometry: {
                  label: {
                    bg: 'Geometry'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            }
          }
        }
      },
      ArchImport: {
        archimport: {
          layers: {
            ArchPlan: {
              sourceTitle: 'ArchPlan',
              idField: 'Id',
              z: 8,
              featureTitle: {
                bg: 'ArchPlan'
              },
              pseudoViewSchema: {0: ViewSchemaType.None},
              tableFields: [
                'Id',
                'Name',
                'ArchPlanTypeId',
                'ArchPlanHistoryStatusId',
                'CreatedUserAlias',
                'Created',
                'PlanCreatedDate'
              ],
              addOnMap: false,
              readOnly: true,
              noRegister: true,
              doNotIdentify: true,
              fieldInfos: {
                CreatedUserAlias: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: true,
                  editable: false
                },
                Name: {
                  label: {
                    bg: 'Име на проекта'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                ValidUntilDate: {
                  label: {
                    bg: 'Валиден до'
                  },
                  visible: true,
                  editable: true,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                ArchPlanTypeId: {
                  label: {
                    bg: 'Тип проект'
                  },
                  visible: true,
                  editable: true
                },
                ArchPlanHistoryStatusId: {
                  label: {
                    bg: 'Състояние'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                PlanCreatedDate: {
                  label: {
                    bg: 'Дата на създаване на проекта'
                  },
                  visible: true,
                  editable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                PlanHistoryId: {
                  label: {
                    bg: 'PlanHistoryId'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Id: {
                  label: {
                    bg: 'Входящ номер'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                }
              }
            },
            ArchPlanHistory: {
              sourceTitle: 'ArchPlanHistory',
              idField: 'Id',
              z: 8,
              featureTitle: {
                bg: 'ArchPlanHistory'
              },
              hasAttachments: true,
              constantSqlWhere: '1=0',
              pseudoViewSchema: {0: ViewSchemaType.Vector},
              tableFields: ['Name'],
              visible: true,
              readOnly: true,
              noRegister: true,
              doNotIdentify: true,
              fieldInfos: {
                CreatedUserAlias: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: true,
                  editable: false
                },
                ArchPlanTypeId: {
                  label: {
                    bg: 'Тип проект'
                  },
                  visible: true,
                  editable: true
                },
                Name: {
                  label: {
                    bg: 'Име на проект'
                  },
                  visible: true,
                  editable: true,
                  nullable: true
                },
                ArchPlanId: {
                  label: {
                    bg: 'ArchPlanId'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ArchPlanHistoryStatusId: {
                  label: {
                    bg: 'Състояние'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                PlanCreatedDate: {
                  label: {
                    bg: 'Дата на създаване на проекта'
                  },
                  visible: true,
                  editable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                Comment: {
                  label: {
                    bg: 'Коментар'
                  },
                  length: 5000,
                  visible: true,
                  editable: true
                },
                MainPdfRealName: {
                  label: {
                    bg: 'MainPdfRealName'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                MainDxfRealName: {
                  label: {
                    bg: 'MainDxfRealName'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: true,
                  editable: false,
                  nullable: true,
                  dateFormat: 'dd.MM.yyyy'
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: true,
                  editable: false,
                  nullable: true
                }
              }
            }
          }
        }
      },
      Common: {
        common: {
          layers: {
            Adress: {
              readOnly: true,
              sourceTitle: 'Адрес',
              idField: 'Id',
              z: 8,
              featureTitle: {
                bg: 'Адрес: {Adr}'
              },
              visible: true,
              pseudoViewSchema: {0: ViewSchemaType.None},
              tableFields: ['Adr'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Adr: {
                  label: {
                    bg: 'Адрес'
                  },
                  visible: true,
                  editable: false
                },
                Region: {
                  label: {
                    bg: 'Област'
                  },
                  visible: false,
                  editable: false
                },
                Municipality: {
                  label: {
                    bg: 'Община'
                  },
                  visible: false,
                  editable: false
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                geometry: {
                  type: 'geometry',
                  label: {bg: 'geometry'},
                  visible: false,
                  nullable: true,
                  editable: false
                }
              }
            },
            Settlement: {
              readOnly: true,
              sourceTitle: 'Населени места',
              idField: 'Id',
              z: 8,
              featureTitle: {
                bg: 'Населено място: {Name}'
              },
              pseudoViewSchema: {0: ViewSchemaType.None},
              tableFields: ['Name', 'EKATTE'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                EKATTE: {
                  label: {
                    bg: 'EKATTE'
                  },
                  visible: true,
                  editable: false
                },
                Name: {
                  label: {
                    bg: 'Име'
                  },
                  visible: true,
                  editable: false
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            },
            Locality: {
              readOnly: true,
              sourceTitle: 'Местности',
              idField: 'Id',
              z: 8,
              featureTitle: {
                bg: 'Местност: {Name}'
              },
              pseudoViewSchema: {0: ViewSchemaType.None},
              tableFields: ['Name'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Name: {
                  label: {
                    bg: 'Име'
                  },
                  visible: true,
                  editable: false
                },
                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            }
          }
        }
      },
      Property: {
        properties: {
          layers: {
            Properties: {
              readOnly: false,
              addOnMap: true,
              sourceTitle: 'Управеление на общински имоти',
              idField: 'Id',
              z: 8,
              featureTitle: {
                bg: 'Общински имот'
              },
              pseudoViewSchema: {10: ViewSchemaType.Vector},
              tableFields: ['Description', 'Address', 'AktNumber', 'AktDate'],
              fieldInfos: {
                Id: {
                  label: {
                    bg: 'Id'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Description: {
                  label: {
                    bg: 'Описание'
                  },
                  visible: true,
                  editable: false
                },
                Adres: {
                  label: {
                    bg: 'Адрес'
                  },
                  visible: true,
                  editable: false
                },
                AktNumber: {
                  label: {
                    bg: 'Номер на акт'
                  },
                  visible: true,
                  editable: true
                },
                AktDate: {
                  label: {
                    bg: 'Дата на акт'
                  },
                  visible: true,
                  editable: true
                },

                Value: {
                  label: {
                    bg: 'Стойност'
                  },
                  visible: true,
                  editable: true
                },
                LastMaintanance: {
                  label: {
                    bg: 'Последно поддръжка'
                  },
                  visible: true,
                  editable: true
                },
                MaintananceDescription: {
                  label: {
                    bg: 'Описание на поддръжката'
                  },
                  visible: true,
                  editable: true
                },
                PropertiesTypeId: {
                  label: {
                    bg: 'Тип на имота'
                  },
                  visible: true,
                  editable: true
                },
                PropertiesStatusId: {
                  label: {
                    bg: 'Статус на имота'
                  },
                  visible: true,
                  editable: true
                },
                PropertiesOwnershipId: {
                  label: {
                    bg: 'Собственост на имота'
                  },
                  visible: true,
                  editable: true
                },
                SettlementId: {
                  label: {
                    bg: 'Населено място'
                  },
                  visible: false,
                  editable: false,
                  nullable: false
                },
                Permissions: {
                  label: {
                    bg: 'Права'
                  },
                  visible: true,
                  editable: true
                },
                CapitalOf: {
                  label: {
                    bg: 'Капитал на'
                  },
                  visible: true,
                  editable: true
                },
                Actions: {
                  label: {
                    bg: 'Действия'
                  },
                  visible: true,
                  editable: true
                },

                Created: {
                  label: {
                    bg: 'Създадено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                Modified: {
                  label: {
                    bg: 'Променено на'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                CreatedBy: {
                  label: {
                    bg: 'Създадено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                },
                ModifiedBy: {
                  label: {
                    bg: 'Променено от'
                  },
                  visible: false,
                  editable: false,
                  nullable: true
                }
              }
            }
          }
        }
      },
      Crosses: {
        crosses: {
          layers: {
            c70k3: {
              readOnly: true,
              sourceTitle: 'Координатни Кръстове 70к3 ',
              idField: 'Description',
              z: 8,
              featureTitle: {
                bg: 'Координатен Кръст: {Description}'
              },
              pseudoViewSchema: {0: ViewSchemaType.TileImage},
              tableFields: ['Description'],
              fieldInfos: {
                Name: {
                  label: {
                    bg: 'Description'
                  },
                  visible: true,
                  editable: false
                }
              }
            },
            c70k5: {
              readOnly: true,
              sourceTitle: 'Координатни Кръстове 70к5 ',
              idField: 'Description',
              z: 8,
              featureTitle: {
                bg: 'Координатен Кръст: {Description}'
              },
              pseudoViewSchema: {0: ViewSchemaType.TileImage},
              tableFields: ['Description'],
              fieldInfos: {
                Name: {
                  label: {
                    bg: 'Description'
                  },
                  visible: true,
                  editable: false
                }
              }
            },
            c70k7: {
              readOnly: true,
              sourceTitle: 'Координатни Кръстове 70к7 ',
              idField: 'Description',
              z: 8,
              featureTitle: {
                bg: 'Координатен Кръст: {Description}'
              },
              pseudoViewSchema: {0: ViewSchemaType.TileImage},
              tableFields: ['Description'],
              fieldInfos: {
                Name: {
                  label: {
                    bg: 'Description'
                  },
                  visible: true,
                  editable: false
                }
              }
            },
            c70k9: {
              readOnly: true,
              sourceTitle: 'Координатни Кръстове 70к9 ',
              idField: 'Description',
              z: 8,
              featureTitle: {
                bg: 'Координатен Кръст: {Description}'
              },
              pseudoViewSchema: {0: ViewSchemaType.TileImage},
              tableFields: ['Description'],
              fieldInfos: {
                Name: {
                  label: {
                    bg: 'Description'
                  },
                  visible: true,
                  editable: false
                }
              }
            },
            c50324: {
              readOnly: true,
              sourceTitle: 'Координатни Кръстове 50324 ',
              idField: 'Description',
              z: 8,
              featureTitle: {
                bg: 'Координатен Кръст: {Description}'
              },
              pseudoViewSchema: {0: ViewSchemaType.TileImage},
              tableFields: ['Description'],
              fieldInfos: {
                Name: {
                  label: {
                    bg: 'Description'
                  },
                  visible: true,
                  editable: false
                }
              }
            },
            c50327: {
              readOnly: true,
              sourceTitle: 'Координатни Кръстове 50327 ',
              idField: 'Description',
              z: 8,
              featureTitle: {
                bg: 'Координатен Кръст: {Description}'
              },
              pseudoViewSchema: {0: ViewSchemaType.TileImage},
              tableFields: ['Description'],
              fieldInfos: {
                Name: {
                  label: {
                    bg: 'Description'
                  },
                  visible: true,
                  editable: false
                }
              }
            },
            c50621: {
              readOnly: true,
              sourceTitle: 'Координатни Кръстове 50621 ',
              idField: 'Description',
              z: 8,
              featureTitle: {
                bg: 'Координатен Кръст: {Description}'
              },
              pseudoViewSchema: {0: ViewSchemaType.TileImage},
              tableFields: ['Description'],
              fieldInfos: {
                Name: {
                  label: {
                    bg: 'Description'
                  },
                  visible: true,
                  editable: false
                }
              }
            },
            c50627: {
              readOnly: true,
              sourceTitle: 'Координатни Кръстове 50627 ',
              idField: 'Description',
              z: 8,
              featureTitle: {
                bg: 'Координатен Кръст: {Description}'
              },
              pseudoViewSchema: {0: ViewSchemaType.TileImage},
              tableFields: ['Description'],
              fieldInfos: {
                Name: {
                  label: {
                    bg: 'Description'
                  },
                  visible: true,
                  editable: false
                }
              }
            },
            c3024: {
              readOnly: true,
              sourceTitle: 'Координатни Кръстове 3024 ',
              idField: 'Description',
              z: 8,
              featureTitle: {
                bg: 'Координатен Кръст: {Description}'
              },
              pseudoViewSchema: {0: ViewSchemaType.TileImage},
              tableFields: ['Description'],
              fieldInfos: {
                Name: {
                  label: {
                    bg: 'Description'
                  },
                  visible: true,
                  editable: false
                }
              }
            },
            c3027: {
              readOnly: true,
              sourceTitle: 'Координатни Кръстове 3027 ',
              idField: 'Description',
              z: 8,
              featureTitle: {
                bg: 'Координатен Кръст: {Description}'
              },
              pseudoViewSchema: {0: ViewSchemaType.TileImage},
              tableFields: ['Description'],
              fieldInfos: {
                Name: {
                  label: {
                    bg: 'Description'
                  },
                  visible: true,
                  editable: false
                }
              }
            }
          }
        }
      }
    }
  }

  for (const key in rawConfig.sourcesDescription[xyApiUrl].namespaces) {
    for (const group in rawConfig.sourcesDescription[xyApiUrl].namespaces[key]) {
      if (group == 'zones') {
        for (const l in rawConfig.sourcesDescription[xyApiUrl].namespaces[key][group].layers) {
          if (l != 'Site' && l != 'SiteLine' && l != 'MatrixZone' && l != 'ConstrBuilding') {
            const lay = rawConfig.sourcesDescription[xyApiUrl].namespaces[key][group].layers[l] as any
            rawConfig.sourcesDescription[xyApiUrl].namespaces[key][group].layers[l] = {
              ...rawConfig.sourcesDescription[xyApiUrl].namespaces[key][group].layers[l],
              idField: 'Id',
              z: 2,
              noRegister: true,
              readOnly: true,
              addOnMap: false,
              pseudoViewSchema: {0: ViewSchemaType.None, 18: ViewSchemaType.Vector},
              featureTitle: {
                bg: 'Устройствена зона {MatrixZoneTypeId}'
              },
              vectorRenderer: {
                def: [
                  {
                    stroke: {width: 0},
                    fill: {color: lay.color}
                  }
                ]
              },
              fieldInfos: matrixFields
            }
          }
        }
      }
    }
  }
}
